<template lang="pug">
  .b2b-page-parties-services
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('party_detail.title') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-button(
                v-if='canAdminIndra && canUpdate',
                type='primary',
                icon='ods-icon-refresh',
                size='small',
                circle,
                @click.native='handleGoMassiveUpdate')
                | {{ $t('party_detail.buttons.mass_partyupdate') }}
              ods-button(
                v-if='canViewComercialRelation && withProject',
                type='primary',
                icon='ods-icon-arrow-right',
                size='small',
                circle,
                @click.native='handleGoCommercialRelation')
                | {{ $t('party_detail.buttons.admin_channels') }}
              ods-button(
                v-if='canAdminProject',
                icon='ods-icon-arrow-right',
                size='small',
                circle,
                @click.native='handleGoCenters')
                | {{ $t('party_detail.buttons.admin_centres') }}

      ods-form(
        ref='projectPartiesDetailEditForm',
        :model='projectPartiesDetailEditForm',
        :rules='projectPartiesDetailEditFormRules',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row.info
          ods-col(:span='24')
            p {{ $t('party_detail.info_message') }}

        //- DATOS GENERALES DE LA EMPRESA
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.person_type.label")',
              prop='personTypeCode')
              ods-select(
                :disabled='!(canAdminIndra || canModifyMasterData)',
                v-model='projectPartiesDetailEditForm.personTypeCode',
                filterable,
                :placeholder='$t("party_detail.party_detail_edit_form.person_type.label")')
                ods-option(
                  v-for='option in optionsTypePerson',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'J'",
              :label='$t("party_detail.party_detail_edit_form.corporate_name")',
              prop='corporateName')
              ods-input(
                :disabled='!(canAdminIndra || (!isSelectedSpain && canModifyMasterData))',
                v-model='projectPartiesDetailEditForm.corporateName')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.name")',
              prop='name')
              ods-input(
                :disabled='!(canAdminIndra || canModifyMasterData)',
                v-model='projectPartiesDetailEditForm.name')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.first_surname")',
              prop='firstSurname')
              ods-input(
                :disabled='!(canAdminIndra || canModifyMasterData)',
                v-model='projectPartiesDetailEditForm.firstSurname')
            ods-form-item(
              v-if="projectPartiesDetailEditForm.personTypeCode === 'F'",
              :label='$t("party_detail.party_detail_edit_form.second_surname")',
              prop='secondSurname')
              ods-input(
                :disabled='!(canAdminIndra || canModifyMasterData)',
                v-model='projectPartiesDetailEditForm.secondSurname')
            ods-form-item(
              v-if='(this.projectPartiesDetailEditForm.editableLogo)',
              label='Logo',
              prop='logo')
                ods-button(
                  icon='ods-icon-plus',
                  size='medium',
                  circle,
                  :disabled='!this.projectPartiesDetailEditForm.editableLogo',
                  @click.native='showUploadDialog')
                  | {{ $t('buttons.btnAdd') }}
                ods-form-item(:label="projectPartiesDetailEditForm.logo && projectPartiesDetailEditForm.logo.name && projectPartiesDetailEditForm.logo.name!=undefined ? projectPartiesDetailEditForm.logo.name : (projectPartiesDetailEditForm.logo ? projectPartiesDetailEditForm.logo : '')" class='labelNameLogo')
                ods-button(
                  v-if='this.projectPartiesDetailEditForm.editableLogo && projectPartiesDetailEditForm.logo != null',
                  type='neutral',
                  @click='removeLogo')
                  ods-icon(name='close', size='24', class="botoneraLogo")
                ods-button(
                  v-if='canAdminProject && projectPartiesDetailEditForm.logo != null && projectPartiesDetailEditForm.logo.name==null',
                  type='neutral',
                  @click='downloadLogo')
                  ods-icon(name='download', size='24', class="botoneraLogo")
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.identification_tax_number")',
              prop='taxIdentificationNumber')
              ods-input(
                :disabled='!(canAdminIndra)',
                v-model='projectPartiesDetailEditForm.taxIdentificationNumber')
            ods-form-item(
              :label='$t("party_detail.party_detail_edit_form.gln")',
              prop='gln')
              ods-input(
                :disabled='!(canAdminIndra || canModifyMasterData)',
                v-model='projectPartiesDetailEditForm.gln')

          //- DATOS DIRECCION
        span.subtitle {{ $t('party_detail.subtitle.address') }}
        ods-row.info_address
          ods-col(:span='24')
            p {{ $t('party_detail.info_address') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.address")',
                prop='address')
                ods-input(
                  :disabled='!this.projectPartiesDetailEditForm.editableAddress',
                  v-model='projectPartiesDetailEditForm.address')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.province")',
                prop='province')
                ods-input(
                  :disabled='!this.projectPartiesDetailEditForm.editableAddress',
                  v-model='projectPartiesDetailEditForm.province')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.postcode")',
                prop='postcode')
                ods-input(
                  :disabled='!this.projectPartiesDetailEditForm.editableAddress',
                  v-model='projectPartiesDetailEditForm.postcode')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.town")',
                prop='town')
                ods-input(
                  :disabled='!this.projectPartiesDetailEditForm.editableAddress',
                  v-model='projectPartiesDetailEditForm.town')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.country.label")',
                prop='countryId')
                ods-select(
                  :disabled='!(canAdminIndra || canModifyMasterData)',
                  v-model='projectPartiesDetailEditForm.countryId',
                  filterable,
                  :placeholder='$t("party_detail.party_detail_edit_form.country.placeholder")')
                  ods-option(
                    v-for='option in countries',
                    :key='option.id',
                    :label='option.name',
                    :value='option.id')
        //- DATOS REGISTRO MERCANTIL
        span.subtitle {{ $t('party_detail.subtitle.commercial_register') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.registerOrCompaniesLocation")',
                prop='registerOrCompaniesLocation')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableRegMercantil)',
                  v-model='projectPartiesDetailEditForm.registerOrCompaniesLocation')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.book")',
                prop='book')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableBook)',
                  v-model='projectPartiesDetailEditForm.book')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.folio")',
                prop='folio')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableFolio)',
                  v-model='projectPartiesDetailEditForm.folio')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.additional_data")',
                prop='additionalRegistrationData')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableAdditionalData)',
                  v-model='projectPartiesDetailEditForm.additionalRegistrationData')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.sheet")',
                prop='sheet')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableSheet)',
                  v-model='projectPartiesDetailEditForm.sheet')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.section")',
                prop='section')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableSection)',
                  v-model='projectPartiesDetailEditForm.section')
            ods-form-item(
                :label='$t("party_detail.party_detail_edit_form.volume")',
                prop='volume')
                ods-input(
                  :disabled='!(this.projectPartiesDetailEditForm.editableVolume)',
                  v-model='projectPartiesDetailEditForm.volume')

        div(v-if='!withProject')
          ods-row(type='flex')
            ods-col(:span='4')
              ods-form-item(
                v-if='canAdminIndra || canModifyRole',
                :label='$t("party_detail.party_detail_edit_form.enable")',
                prop='enable')
                ods-switch(
                  @click.native='updateOnclickSwitch()'
                  :disabled='!(canAdminIndra || canModifyRole)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  v-model='projectPartiesDetailEditForm.enable')
          //- ROL POR SERVICIO
        div(v-if='withProject')
          span.subtitle {{ $t('party_detail.subtitle.project_role') }}
          ods-row(type='flex')
            ods-col(:span='4')
              ods-form-item(
                  ref='buyerFormItem'
                  :label='$t("party_detail.party_detail_edit_form.buyer")',
                  prop='buyer')
                  ods-switch(
                    @click.native='updateOnclickSwitch()'
                    :disabled='!(canAdminIndra || canModifyRole)',
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    v-model='projectPartiesDetailEditForm.buyer')
            ods-col(:span='4')
              ods-form-item(
                  ref='sellerFormItem'
                  :label='$t("party_detail.party_detail_edit_form.seller")',
                  prop='seller')
                  ods-switch(
                    @click.native='updateOnclickSwitch()'
                    :disabled='!(canAdminIndra || canModifyRole)',
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    v-model='projectPartiesDetailEditForm.seller')
            ods-col(:span='4')
              ods-form-item(
                  ref='thirdFormItem'
                  :label='$t("parties.entity_table.third")',
                  prop='third')
                  ods-switch(
                    @click.native='updateOnclickSwitch()'
                    :disabled='!(canAdminIndra || canModifyRole)',
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    v-model='projectPartiesDetailEditForm.third')
            ods-col(:span='4')
              ods-form-item(
                v-if='canAdminIndra || canModifyRole',
                :label='$t("party_detail.party_detail_edit_form.enable")',
                prop='enable')
                ods-switch(
                  @click.native='updateOnclickSwitch()'
                  :disabled='!(canAdminIndra || canModifyRole)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  v-model='projectPartiesDetailEditForm.projectpartyenable')
            ods-col(:span='4')
              ods-form-item(
                  v-if='canAdminIndra'
                  :label='$t("party_detail.party_detail_edit_form.sponsor")',
                  prop='sponsor')
                  ods-switch(
                    @click.native='updateOnclickSwitch()'
                    :disabled='!(canAdminIndra)',
                    :active-color='primaryColor',
                    inactive-color='#D5DCE0',
                    v-model='projectPartiesDetailEditForm.sponsor')

    ods-row.form-actions()
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            :disabled='!(canAdminIndra || this.projectPartiesDetailEditForm.editable || this.projectPartiesDetailEditForm.editableAddress || this.projectPartiesDetailEditForm.editableMercantil || canModifyParty)',
            @click='saveProjectParty("projectPartiesDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            ref='buttonCancel',
            size='large'
            :disabled='!(canAdminIndra || this.projectPartiesDetailEditForm.editable || this.projectPartiesDetailEditForm.editableAddress || this.projectPartiesDetailEditForm.editableMercantil || canModifyParty)',
            type='neutral',
            @click='cancelprojectPartiesDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse(v-if='!withProject')
      ods-accordion(@change='loadProjectsParty')
        ods-accordion-item( name='0')
          template(slot='title')
            span {{ $t('party_detail.project_related') }}
            span.info(v-show='!projectsParty.length && projectsPartyMessage') {{ $t('party_detail.no_project_data') }}
          //- Tabla de proyectos
          ods-table(
            v-if='projectsParty.length > 0 ',
            :data='projectsParty',
            :default-sort="{ prop: 'projectName', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterProjects',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='projectName',
              :label='$t("projects.entity_table.name")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='projectCode',
              :label='$t("projects.entity_table.code")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='seller',
              :label='$t("parties.entity_table.seller")',
              sortable='custom')
              template(slot-scope='scope')
                ods-switch(v-model='scope.row.seller',
                  :disabled='!(canAdminIndra)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  @change='updateSeller(scope.row)')
            ods-table-column(
              prop='buyer',
              :label='$t("parties.entity_table.buyer")',
              sortable='custom')
              template(slot-scope='scope')
                ods-switch(v-model='scope.row.buyer',
                  :disabled='!(canAdminIndra)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  @change='updateBuyer(scope.row)')
            ods-table-column(
              prop='third',
              :label='$t("parties.entity_table.third")',
              sortable='custom')
              template(slot-scope='scope')
                ods-switch(v-model='scope.row.third',
                  :disabled='!(canAdminIndra)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  @change='updateThird(scope.row)')
            ods-table-column(
              prop='sponsor',
              :label='$t("parties.entity_table.sponsor")',
              sortable='custom')
              template(slot-scope='scope')
                ods-switch(v-model='scope.row.sponsor',
                  :disabled='!(canAdminIndra)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  @change='updateSponsor(scope.row)')
            ods-table-column(
              prop='enable',
              :label='$t("parties.entity_table.enable")',
              sortable='custom')
              template(slot-scope='scope')
                ods-switch(
                  v-model='scope.row.enable',
                  :disabled='!(canAdminIndra || canModifyProject || canModifyRole)',
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  @change='updateStatusParty(scope.row)')

    ods-module.collapse(v-if='withProject')
      ods-accordion(@change='loadPartyMedia')
        ods-accordion-item( name='1')
          template(slot='title')
            span {{ $t('party_detail.contact_data') }}
            span.info(v-show='!datapartymedia.length && partyMediaMessage') {{ $t('party_detail.no_contact_data') }}
          //- Tabla de partymedia
          ods-table(
            v-if='datapartymedia.length > 0 ',
            :data='datapartymedia',
            :default-sort="{ prop: 'id', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='mediaTypeId',
              :label='$t("party_detail.party_media_table.media_type")',
              :show-overflow-tooltip='true',
              :formatter='formatterMediaType',
              sortable='')
            ods-table-column(
              prop='mediaValue',
              :label='$t("party_detail.party_media_table.contact_data")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='typeText',
              :label='$t("party_detail.party_media_table.party_type")',
              :formatter='formatterPartyType',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canChangePartyMedia',
                  type='neutral',
                  @click='removePartyMedia')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("party_detail.buttons.add_contact_data_tooltip")', placement='bottom')
            ods-button.button-collapse(
              v-if='canChangePartyMedia',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogPartyMedia = true')
              | {{ $t('party_detail.buttons.add_contact_data') }}
        //- Buzones
        ods-accordion(@change='loadPartyGln')
          ods-accordion-item( name='1b')
            template(slot='title')
              span {{ $t('party_detail.gln_data') }}
              span.info(v-show='!partygln.length && partyGlnMessage') {{ $t('party_detail.no_gln_data') }}
            //- Tabla de buzones
            ods-table(
              v-if='partygln.length > 0 ',
              :data='partygln',
              :default-sort="{ prop: 'id', order: 'descending' }",
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterGln',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='physicalGln',
                :label='$t("party_detail.party_gln_table.physical_gln")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canAdminParty',
                    type='neutral',
                    @click='removePartyGln')
                    ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("party_detail.buttons.add_gln_data_tooltip")', placement='bottom')
              ods-button.button-collapse(
                v-if='canAdminParty',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='isShowDialogPartyGln = true')
                | {{ $t('party_detail.buttons.add_gln_data') }}
        //- Metodos de entrega
        ods-accordion(@change='loadCommunicationsMethods')
          ods-accordion-item( name='2',
          v-if='isBuyer')
            template(slot='title')
              span {{ $t('party_detail.delivery_methods') }}
              span.info(v-show='!communicationsmethods.length && communicationsMethodsMessage') {{ $t('party_detail.no_delivery_methods') }}
            //- Tabla metodos de entrega de una empresa
            ods-table(
              v-if='communicationsmethods.length > 0 ',
              :data='communicationsmethods',
              :default-sort="{ prop: 'name', order: 'ascending' }",
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterMethod',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='name',
                :label='$t("party_detail.delivery_methods_table.name")',
                :show-overflow-tooltip='true',
                :formatter='formatterDeliveryMethods',
                sortable='')
              ods-table-column(
                prop='sender',
                :label='$t("party_detail.delivery_methods_table.sender")',
                :show-overflow-tooltip='true',
                :formatter='formatterSenderType',
                sortable='')
              ods-table-column(
                prop='priority',
                :label='$t("party_detail.delivery_methods_table.priority")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='projectName',
                :formatter='formatterServiceName',
                :label='$t("profiles.profiles_table.project")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canEditPartyDeliveryMethod && scope.row.delete',
                    type='neutral',
                    @click='removeCommunicationsMethodsParty')
                    ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("party_detail.buttons.add_delivery_method_tooltip")', placement='bottom')
              ods-button.button-collapse(
                v-if='canEditPartyDeliveryMethod',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='openDialogDeliveryMehods()')
                | {{ $t('party_detail.buttons.add_delivery_method') }}

        //- VALIDACIONES (EMPRESAS VENDEDORAS Y SPONSOR DEL PROYECTO)
        ods-accordion(@change='loadPartyValidations')
          ods-accordion-item( name='3',
          v-if='isSponsor && isShowValidations')
            template(slot='title')
              span {{ $t('project_detail.validations') }}
              span.info(v-show='!validationsData.length && partyValidationsMessage') {{ $t('party_detail.no_active_validations') }}
            //- Tabla validaciones
            ods-table(
              v-if='validationsData.length > 0 ',
              :data='validationsData',
              :default-sort="{ prop: 'name', order: 'ascending' }",
              style='width: 100%',
              @cell-mouse-enter='handleValidationCellMouseEnter',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='name',
                :label='$t("projects.validations.name")',
                :show-overflow-tooltip='true',
                :formatter='formatterName'
                sortable='')
              ods-table-column(
                prop='value',
                :label='$t("projects.validations.value")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='sender',
                :formatter='formatterRole',
                :label='$t("projects.validations.role")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='documentType',
                :label='$t("projects.validations.document_type")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='country',
                :label='$t("projects.validations.country")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='documentFormat',
                :label='$t("projects.validations.document_format")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                label=''
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canAdminIndra',
                    type='neutral',
                    @click='removeValidation')
                    ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("party_detail.buttons.add_validations_tooltip")', placement='bottom')
              ods-button.button-collapse(
                v-if='canAdminIndra',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='openDialogAddValidation()')
                | {{ $t('buttons.btnAdd') }}

        //-FIRMA DELEGADA
        ods-accordion(@change='loadSignDocument')
          ods-accordion-item(
            v-if='canSeeSingDocument',
            name='4')
            template(slot='title')
              span {{ $t('party_detail.sign_document') }}
              span.info(v-show='!dataSignDocument.length && signDocumentMessage') {{ $t('party_detail.no_sign_document') }}
            //- Tabla de firma delegada
            ods-table(
              v-if='dataSignDocument.length > 0 ',
              :data='dataSignDocument',
              :default-sort="{ prop: 'id', order: 'descending' }",
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterSingDocument',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='projectName',
                :label='$t("party_detail.sign_document_table.project")',
                :show-overflow-tooltip='true',
                :formatter='formatterTypeService',
                sortable='')
              ods-table-column(
                prop='filename',
                :label='$t("party_detail.sign_document_table.filename")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='creationDateTime',
                :label='$t("party_detail.sign_document_table.creation_date")',
                :show-overflow-tooltip='true',
                :formatter='formatterDate',
                sortable='')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-button.first-button(
                    v-if='canDeleteSingDocument',
                    type='neutral',
                    @click='removeSingDocument')
                    ods-icon(name='close', size='16')
                  ods-button(
                    v-if='canSeeSingDocument && scope.row.filename && scope.row.filename.length > 0',
                    type='neutral',
                    @click='downloadSingDoc')
                    ods-icon(name='download', size='16')
            ods-tooltip(:content='$t("party_detail.buttons.add_sign_document_tooltip")', placement='bottom')
              ods-button.button-collapse(
                v-if='canAddSingDocument',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='showDialogSignDocument')
                | {{ $t('party_detail.buttons.add_sign_document') }}
        //- Acordeon Bloque PDF
        ods-accordion(@change='loadPdfData')
          ods-accordion-item(name='5')
            template(slot='title')
              span {{ $t('project_detail.visualize_pdf') }}
              span.info(v-show='!pdfData.length && pdfDataMessage') {{ $t('project_detail.no_active_PDF') }}
            //- Tabla de datos de visualizaciones
            ods-table(
              v-if='pdfData.length > 0 ',
              :data='pdfData',
              :default-sort="{ prop: 'name', order: 'descending' }",
              style='width: 100%',
              @cell-mouse-enter='handlePDFCellMouseEnter',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='name',
                :label='$t("projects.validations.name")',
                :show-overflow-tooltip='true',
                :formatter='formatterVisualizationName'
                sortable='')
              ods-table-column(
                prop='documentType',
                :label='$t("projects.validations.document_type")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='issueDirection',
                :formatter='formatterDirection',
                :label='$t("projects.validations.role")',
                :show-overflow-tooltip='true'
                sortable='')
              ods-table-column(
                prop='communicationMethod',
                :label='$t("projects.validations.comm_method")',
                :show-overflow-tooltip='true'
                :formatter='formatterDeliveryMethods',
                sortable='')
              ods-table-column(
                label=''
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canAdminIndra',
                    type='neutral',
                    @click='removePDFVisualization')
                    ods-icon(name='close', size='16')
            ods-tooltip(v-if='canAdminIndra', :content='$t("project_detail.buttons.add_visualization_tooltip")', placement='bottom')
              ods-button.button-collapse(
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='openDialogAddPDFVisualization()')
                | {{ $t('buttons.btnAdd') }}
        //- Desplegable FORMATOS DOCUMENTOS
        ods-accordion(@change='loadPartyDocumentFormat')
          ods-accordion-item( name='6',
            v-if='isBuyer')
              template(slot='title')
                span {{ $t('party_detail.document_format') }}
                span.info(v-show='!partyDocumentFormat.length && partyDocumentFormatMessage') {{ $t('party_detail.no_document_format') }}
              ods-table(
                v-if='partyDocumentFormat.length > 0 ',
                :data='partyDocumentFormat',
                :default-sort="{ prop: 'documentType', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterFormat',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='documentType',
                  :label='$t("party_detail.document_format_table.documentType")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='documentFormatName',
                  :label='$t("party_detail.document_format_table.format")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='sender',
                  :label='$t("party_detail.document_format_table.sender")',
                  :show-overflow-tooltip='true',
                  :formatter='formatterSenderType',
                  sortable='')
                ods-table-column(
                  prop='priority',
                  :label='$t("party_detail.document_format_table.priority")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyDocumentFormat')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_document_format_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogPartyDocumentFormat()')
                  | {{ $t('party_detail.buttons.add_delivery_method') }}

        //- Desplegable CONFIGURACION DE EMISIÓN DE ALBARANES
        ods-accordion(@change='loadPartyEmissionDeliveryNoteConfig')
          ods-accordion-item( name='6',
            v-if='isSeller')
              template(slot='title')
                span {{ $t('party_detail.emission_delivery_note_config') }}
                span.info(v-show='partyDeliveryNoteConfig != null && partyDeliveryNoteConfig != undefined && !partyDeliveryNoteConfig.length && partyEmissionDeliveryNoteConfigMessage') {{ $t('party_detail.no_emission_delivery_note_config') }}
              ods-table(
                v-if='partyDeliveryNoteConfig != null && partyDeliveryNoteConfig != undefined && partyDeliveryNoteConfig.length > 0 ',
                :data='partyDeliveryNoteConfig',
                @cell-mouse-enter='handleCellMouseEnterEmissionDeliveryNoteConfig',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='platformCode',
                  :label='$t("party_detail.emission_delivery_note_config_table.platformCode")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='partyPrefix',
                  :label='$t("party_detail.emission_delivery_note_config_table.partyPrefix")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='packSequenceNumber',
                  :label='$t("party_detail.emission_delivery_note_config_table.packSequenceNumber")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyEmissionDeliveryNoteConfig')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_registration_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra && (partyDeliveryNoteConfig === null || partyDeliveryNoteConfig === undefined || partyDeliveryNoteConfig.length === 0)',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogAddPartyDeliveryNoteConfig()')
                  | {{ $t('party_detail.buttons.add_delivery_method') }}

        //- Desplegable CONFIGURACION DE RECEPCION DE ALBARANES
        ods-accordion(@change='loadPartyDeliveryNoteType')
          ods-accordion-item( name='6',
            v-if='isBuyer')
              template(slot='title')
                span {{ $t('party_detail.reception_delivery_note_config') }}
                span.info(v-show='partyDeliveryNoteType != null && partyDeliveryNoteType != undefined && !partyDeliveryNoteType.length && partyDeliveryNoteTypeMessage') {{ $t('party_detail.no_party_reception_delivery_note_config')}}
              ods-table(
                v-if='partyDeliveryNoteType.length > 0 ',
                :data='partyDeliveryNoteType',
                :default-sort="{ prop: 'deliveryNoteTypeCode', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterDeliveryNoteType',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='deliveryNoteTypeCode',
                  :label='$t("party_detail.reception_delivery_note_config_table.delivery_note_type")',
                  :formatter='formatterDeliveryNoteType'
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyDeliveryNoteType')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_delivery_note_type_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogAddPartyDeliveryNoteType()')
                  | {{ $t('party_detail.buttons.add_delivery_method') }}

        //- Desplegable CONFIGURACION DE ETIQUETAS
        ods-accordion(@change='loadPartyLabel')
          ods-accordion-item( name='6',
            v-if='isBuyer')
              template(slot='title')
                span {{ $t('party_detail.party_label_config') }}
                span.info(v-show='partyLabel != null && partyLabel != undefined && !partyLabel.length && partyLabelMessage') {{ $t('party_detail.no_party_label_config')}}
              ods-table(
                v-if='partyLabel.length > 0 ',
                :data='partyLabel',
                :default-sort="{ prop: 'name', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterPartyLabel',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='name',
                  :formatter='formatterLabel'
                  :label='$t("party_detail.party_label_config_table.name")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyLabel')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_label_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='openDialogAddPartyLabel()')
                  | {{ $t('party_detail.buttons.add_delivery_method') }}

        //- Desplegable ciclos de documentos
        ods-accordion(@change='loadPartyDocumentCycle')
          ods-accordion-item( name='6',
            v-if='canAdminIndra && isBuyer')
              template(slot='title')
                span {{ $t("party_detail.document_cycle_table.title") }}
                span.info(v-show='!partyDocumentCycles.length && partyDocumentCycleMessage') {{ $t("party_detail.no_party_document_cycle") }}
              ods-table(
                v-if='partyDocumentCycles.length > 0 ',
                :data='partyDocumentCycles',
                :default-sort="{ prop: 'sourceDocumentType', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterPartyDocumentCycle',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='sourceDocumentType',
                  :label='$t("party_detail.document_cycle_table.sourceDocumentType")',
                  :show-overflow-tooltip='true',
                  :formatter='formatterDocumentType',
                  sortable='')
                ods-table-column(
                  prop='destinationDocumentType',
                  :label='$t("party_detail.document_cycle_table.destinationDocumentType")',
                  :show-overflow-tooltip='true',
                  :formatter='formatterDocumentType',
                  sortable='')
                ods-table-column(
                  prop='centreBuyer',
                  :label='$t("party_detail.document_cycle_table.buyer_centre")',
                  sortable='')
                  template(slot-scope='scope')
                    ods-tooltip(placement='top-end')
                      template(slot='content')
                        | {{ scope.row.centreBuyerCode }}
                        br
                        | {{ scope.row.centreBuyerTooltip }}
                      div.text-overflow-tooltip
                        | {{ scope.row.centreBuyerCode }}
                ods-table-column(
                  prop='partySellerName',
                  :label='$t("party_detail.document_cycle_table.seller")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='documentCycleClassName',
                  :label='$t("party_detail.document_cycle_table.class")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(v-if='scope.row.documentCycleClassName', slot-scope='scope')
                    ods-tooltip(placement='bottom')
                      template(slot='content')
                        | {{ scope.row.documentCycleClassDescription }}
                      div.text-overflow-tooltip
                        | {{ $t('document_cycle_class.' + scope.row.documentCycleClassName) }}
                ods-table-column(
                  prop='additionalClassValue',
                  :label='$t("party_detail.document_cycle_table.additional")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyDocumentCycle')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_document_cycle_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogPartyDocumentCycle()')
                  | {{ $t('buttons.btnAdd') }}

        //- Datos fiscales
        ods-accordion(@change='loadAeatDocument')
          ods-accordion-item(name='7')
            template(slot='title')
              span {{ $t('party_detail.aeat_document') }}
              span.info(v-show='!dataAeatDocument.length && aeatDocumentMessage') {{ $t('party_detail.no_aeat_document') }}
            //- Tabla de documentos de datos fiscales
            ods-table(
              v-if='dataAeatDocument.length > 0 ',
              :data='dataAeatDocument',
              :default-sort='{ prop: "creationDate", order: "descending" }',
              style='width: 100%',
              @cell-mouse-enter='handleCellMouseEnterAeatDocument',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='documentname',
                v-if='canAdminIndra',
                :label='$t("party_detail.aeat_document_table.documentname")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='user',
                :label='$t("party_detail.aeat_document_table.user")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='creationDateTime',
                :label='$t("party_detail.aeat_document_table.creation_date")',
                align='center',
                :show-overflow-tooltip='true',
                :formatter='formatterDate',
                sortable='')
              ods-table-column(
                width='80')
                template(slot-scope='scope')
                  ods-tooltip(:content='$t("buttons.btnDownload")', placement='bottom')
                    ods-button.first-button(
                      type='neutral',
                      @click='downloadAeatDoc')
                      ods-icon(name='download', size='16')

        //- Desplegable CONFIGURACIÓN ENVÍOS
        ods-accordion(@change='loadPartyGlnConfiguration')
          ods-accordion-item( name='8',
            v-if='isBuyer')
              template(slot='title')
                span {{ $t('party_detail.shipping_configuration') }}
                span.info(v-show='!partyGlnConfiguration.length && partyGlnConfigurationMessage') {{ $t('party_detail.no_shipping_configuration') }}
              ods-table(
                v-if='partyGlnConfiguration.length > 0 ',
                :data='partyGlnConfiguration',
                :default-sort="{ prop: 'documentType', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterGlnConfiguration',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='documentType',
                  :label='$t("party_detail.shipping_configuration_table.documentType")',
                  :show-overflow-tooltip='true',Type
                  :formatter='formatterDocumentType',
                  sortable='')
                ods-table-column(
                  prop='documentFormat',
                  :label='$t("party_detail.shipping_configuration_table.documentFormat")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='partyGlnBuyer',
                  :label='$t("party_detail.shipping_configuration_table.buyerGLN")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='deliveryCentreCode',
                  :label='$t("party_detail.shipping_configuration_table.deliveryPoint")',
                  :show-overflow-tooltip='true',
                  :formatter='formatterDeliveryCentre',
                  sortable='')
                ods-table-column(
                  prop='partySellerName',
                  :label='$t("party_detail.shipping_configuration_table.partySeller")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='partyGlnSeller',
                  :label='$t("party_detail.shipping_configuration_table.sellerGLN")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removePartyGlnConfiguration')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_shipping_configuration_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogPartyGlnConfiguration()')
                  | {{ $t('party_detail.buttons.add_shipping_configuration') }}

      ods-accordion(@change='loadPaymentMeans')
        ods-accordion-item( v-if='canModifyPaymentMethods', name='9')
          template(slot='title')
            span {{ $t('party_detail.paymentMeans') }}
            span.info(v-show='!paymentMeans.length && paymentMeansMessage') {{ $t('party_detail.no_payment_data') }}
          //- Tabla de partymedia
          ods-table(
            v-if='paymentMeans.length > 0 ',
            :data='paymentMeans',
            :default-sort="{ prop: 'id', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterPaymentMeans',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='paymentMeans',
              :label='$t("party_detail.payments_table.paymentMeans")',
              :show-overflow-tooltip='true',
              :formatter='formatterPayment',
              sortable='')
            ods-table-column(
              prop='iban',
              :label='$t("party_detail.payments_table.iban")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='swift',
              :label='$t("party_detail.payments_table.swift")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removePartyPaymentMeans')
                  ods-icon(name='close', size='16')

          ods-tooltip(:content='$t("party_detail.buttons.add_paymentMeans_tooltip")', placement='bottom')
            ods-button.button-collapse(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='showDialogPaymentMeans()')
              | {{ $t('buttons.btnAdd') }}

    //- Dialogo Cargar logo
    ods-dialog(
      ref='dialogAddLogo',
      :title='$t("party_detail.dialog_add_logo.title")',
      :visible.sync='isShowDialogAddLogo',
      @close='handleCloseDialogAddLogo',
      width='30%')
      ods-form(
        ref='formDialogAddLogo',
        :model='formDialogAddLogo',
        :rules='rulesDialogAddLogoForm')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddLogo.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormatsLogo.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddLogo("formDialogAddLogo")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo Datos de contacto partymedia
    ods-dialog(
      ref='dialogPartyMedia',
      :title='$t("party_detail.dialog_add_contact_data.title")',
      :visible.sync='isShowDialogPartyMedia',
      @close='handleCloseDialogPartyMedia',
      width='30%')
      ods-form(
        ref='formDialogPartyMedia',
        :model='dialogPartyMediaForm',
        :rules='rulesPartyMediaForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.media_type.label")',
            prop='mediaTypeId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyMediaForm.mediaTypeId',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.media_type.placeholder")')
              ods-option(
                v-for='option in optionsFilterMediaType',
                :key='option.id',
                :label='$t("mediaType." + option.media)',
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.party_type.label")',
            prop='rol')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyMediaForm.rol',
              filterable,
              :placeholder='$t("party_detail.dialog_add_contact_data.party_type.placeholder")')
              ods-option(
              v-for='option in comboTypeList',
              :key='option.code',
              :label='$t(option.description)',
              :value='option.code')
          ods-form-item(
            :label='$t("party_detail.dialog_add_contact_data.contact_data.label")',
            prop='value')
            ods-input(
              v-model.trim='dialogPartyMediaForm.value')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyMedia("formDialogPartyMedia")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo Buzones
    ods-dialog(
      ref='dialogPartyGln',
      :title='$t("party_detail.dialog_add_gln_data.title")',
      :visible.sync='isShowDialogPartyGln',
      @close='handleCloseDialogPartyGln',
      width='30%')
      ods-form(
        ref='formDialogPartyGln',
        :model='dialogPartyGlnForm',
        :rules='rulesPartyGlnForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_gln_data.physical_gln.label")',
            prop='physicalGln')
            ods-input(
              v-model='dialogPartyGlnForm.physicalGln')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyGln("formDialogPartyGln")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo métodos de entrega
    ods-dialog(
      ref='dialogCommunicationsMethods',
      :title='$t("party_detail.dialog_add_delivery_methods.title")',
      :visible.sync='isShowDialogDeliveryMehods',
      @close='handleCloseDialogCommunicationsMethods',
      width='30%')
      ods-form(
        ref='formDialogCommunicationsMethods',
        :model='dialogCommunicationsMethodsForm',
        :rules='rulesDialogCommunicationsMethodsForm')
          ods-form-item(
            v-if='showCommunicationFilter',
            :label='$t("party_detail.delivery_methods_table.sender")',
            prop='communicationsmethodsSenderId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsSender',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsSenderId',
              filterable)
              ods-option(
                v-for='option in optionsCommunicationsMethodsSender',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_delivery_methods.method.label")',
            prop='communicationsmethodsId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsMethods',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsId',
              :placeholder='$t("party_detail.dialog_add_delivery_methods.method.placeholder")',
              filterable)
              ods-option(
                v-for='option in optionsFilterCommunicationsMethods',
                :key='option.id',
                :label="$t('communication_method.' + option.name)",
                :value='option.id')
          ods-form-item(v-if='isSuperAdmin')
            ods-checkbox(v-model='dialogCommunicationsMethodsForm.checkAddAll')
              span {{ $t('msg_generics.add_all_projects') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addCommunicationsMethodsParty("formDialogCommunicationsMethods")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir validaciones
    ods-dialog(
      ref='dialogValidations'
      :title='$t("project_detail.dialog_add_validations.title")',
      :visible.sync='isShowDialogValidations',
      @close='handleCloseDialogValidations',
      width='30%')
      ods-form(
        ref='formDialogValidations',
        :model='dialogValidationsForm',
        :rules='rulesDialogValidationsForm')
          ods-form-item(
            prop='validationId',
            :label='$t("project_detail.dialog_add_validations.validation.title")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeValidation',
              v-model='dialogValidationsForm.validationId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_validations.validation.placeholder")')
              ods-option(
                v-for='option in optionsPartyValidations',
                :key='option.idBusinessValidation',
                :label='option.name',
                :value='option.idBusinessValidation')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validations.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeDocumentType',
              v-model='dialogValidationsForm.documentType',
              filterable,
              :placeholder='$t("projects.validations.document_type")')
              ods-option(
                v-for='option in optionsDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.id')
          ods-form-item(
            prop='country',
            :label='$t("projects.validations.country")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.country',
              filterable,
              :placeholder='$t("projects.validities.country")')
              ods-option(
                v-for='option in countries',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            prop='documentFormat',
            v-if='showComboFormat'
            :label='$t("projects.validations.document_format")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.documentFormat',
              filterable,
              :placeholder='$t("projects.validations.document_format")')
              ods-option(
                v-for='option in partyDocumentFormatByType',
                :key='option.id',
                :label='option.name',
                :value='option.name')
          ods-form-item(
            prop='role',
            :label='$t("projects.validations.role")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.role',
              filterable,
              :placeholder='$t("projects.validations.role")')
              ods-option(
                v-for='option in comboRoleList',
                :key='option.code',
                :label='$t(option.description)',
                :value='option.code')
          ods-form-item(
              :label='$t("projects.validations.value")',
              prop='value')
              ods-input(
                v-model='dialogValidationsForm.value')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddValidation("formDialogValidations")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo firma delegada
    ods-dialog(
      ref='dialogAddSignDocument',
      :title='$t("party_detail.dialog_add_sign_document.title")',
      :visible.sync='isShowDialogSignDocument',
      @close='handleCloseDialogSignDocument',
      width='30%')
      ods-form(
        ref='formDialogAddSignDocument',
        :model='formDialogAddSignDocument',
        :rules='rulesDialogSignDocumentForm')
        ods-form-item(prop='file_sign_document', ref='form-item-upload-sign-document')
          ods-upload(
            v-model='formDialogAddSignDocument.file_sign_document',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUploadSignDocument',
            :on-remove='handleRemoveUploadSignDocument',
            :file-list='fileListSignDocument',
            :accept='extensionFormats.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='selectFile')
              | {{ $t('msg_generics.file_selected') }}
        ods-form-item(v-if='isSuperAdmin')
            ods-checkbox(v-model='formDialogAddSignDocument.checkAddAll')
              span {{ $t('msg_generics.add_all_projects') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='uploadSignDocument("formDialogAddSignDocument")')
          | {{ $t('buttons.btnAdd') }}
    //- Dialogo añadir visualización PDF
    ods-dialog(
      ref='dialogPDFVisualization'
      :title='$t("project_detail.dialog_add_visualization.title")',
      :visible.sync='isShowDialogPDFVisualizations',
      @close='handleCloseDialogPDFVisualizations',
      width='30%')
      ods-form(
        ref='formDialogPDFVisualizations',
        :model='dialogPDFVisualizationsForm',
        :rules='rulesDialogPDFVisualizationsForm')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validations.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.documentType',
              filterable,
              @change='getDisplayDocumentsByDocumentType',
              :placeholder='$t("projects.validations.document_type")')
              ods-option(
                v-for='option in optionsDocumentType',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='visualizationId',
            v-if='isSelectedDocType',
            :label='$t("project_detail.dialog_add_visualization.visualization.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.visualizationId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_visualization.visualization.placeholder")')
              ods-option(
                v-for='option in optionsPartyPDFVisualizations',
                :key='option.id',
                :label='$t("display_documents." + option.name)',
                :value='option.id')
          ods-form-item(
            prop='issueDirection',
            v-if='isSelectedDocType',
            :label='$t("projects.validations.role")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.issueDirection',
              filterable,
              :placeholder='$t("projects.validations.role")')
              ods-option(
                v-for='option in comboDirectionList',
                :key='option.code',
                :label='option.description',
                :value='option.code')
          ods-form-item(
            prop='communicationsmethodsId',
            v-if='isSelectedDocType',
            :label='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.communicationsmethodsId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
              ods-option(
                v-for='option in communicationsmethods',
                :key='option.id',
                :label="$t('communication_method.'+option.name)",
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          :disabled='!isSelectedDocType'
          type='primary',
          @click.native='onSubmitAddPDFVisualization("formDialogPDFVisualizations")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir etiqueta
    ods-dialog(
      ref='dialogAddPartyLabel'
      :title='$t("party_detail.dialog_add_party_label.title")',
      :visible.sync='isShowDialogAddPartyLabel',
      @close='handleCloseDialogAddPartyLabel',
      width='30%')
      ods-form(
        ref='formDialogAddPartyLabel',
        :model='dialogAddPartyLabelForm',
        :rules='rulesDialogAddPartyLabelForm')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validations.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              :disabled='true',
              v-model='dialogAddPartyLabelForm.documentType',
              filterable,
              @change='getLabelsByDocumentType',
              :placeholder='$t("projects.validations.document_type")')
              ods-option(
                v-for='option in optionsDocumentTypeDeliveryNoteOnly',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='labelId',
            v-if='isSelectedDocType',
            :label='$t("party_detail.dialog_add_party_label_config.method.label.title")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogAddPartyLabelForm.labelId',
              filterable,
              :placeholder='$t("party_detail.dialog_add_party_label_config.method.label.placeholder")')
              ods-option(
                v-for='option in optionsPartyLabel',
                :key='option.id',
                :label='$t("display_labels." + option.name)',
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          :disabled='!isSelectedDocType'
          type='primary',
          @click.native='onSubmitAddPartyLabel("formDialogAddPartyLabel")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo FORMATO DOCUMENTO
    ods-dialog(
      ref='dialogAddPartyDocumentFormat',
      :title='$t("party_detail.dialog_add_document_format.title")',
      :visible.sync='isShowDialogPartyDocumentFormat',
      @close='handleCloseDialogPartyDocumentFormat',
      width='30%')
      ods-form(
        ref='formDialogAddPartyDocumentFormat',
        :model='dialogPartyDocumentFormatForm',
        :rules='rulesDialogPartyDocumentFormatForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_document_format.method.labelType")',
            prop='documentType')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyDocumentFormatForm.documentType',
              :placeholder='$t("party_detail.dialog_add_document_format.method.placeholder")',
              @change='onChangeDocumentType',
              filterable)
              ods-option(
                v-for='option in partyDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_document_format.method.labelFormat")',
            prop='documentFormat')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyDocumentFormatForm.documentFormat',
              :placeholder='$t("party_detail.dialog_add_document_format.method.placeholder")',
              filterable)
              ods-option(
                v-for='option in partyDocumentFormatByType',
                :key='option.id',
                :label="$t(option.name)",
                :value='option.id')
          ods-form-item(
            :label='$t("party_detail.document_format_table.sender")',
            prop='senderId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyDocumentFormatForm.senderId',
              filterable)
              ods-option(
                v-for='option in optionsPartyDocumentFormatSender',
                :key='option.id',
                :label='option.name',
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyDocumentFormat("formDialogAddPartyDocumentFormat")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo CONFIGURACIÓN DE EMISIÓN DE ALBARANES
    ods-dialog(
      ref='dialogAddPartyDeliveryNoteEmissionConfig',
      :title='$t("party_detail.dialog_add_party_delivery_note_config.title")',
      :visible.sync='isShowDialogAddPartyDeliveryNoteConfig',
      @close='handleCloseDialogAddPartyDeliveryNoteEmissionConfig',
      width='30%')
      ods-form(
        ref='formDialogAddPartyDeliveryNoteEmissionConfig',
        :model='dialogAddPartyDeliveryNoteEmissionConfigForm',
        :rules='rulesDialogAddPartyDeliveryNoteEmissionConfigForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_party_delivery_note_config.method.platformCode")',
            :default='5'
            prop='platformCode')
            ods-input(
                :maxlength='1'
                :disabled='true'
                v-model='dialogAddPartyDeliveryNoteEmissionConfigForm.platformCode')
          ods-form-item(
            :label='$t("party_detail.dialog_add_party_delivery_note_config.method.partyPrefix.title")',
            prop='partyPrefix')
            ods-input(
                :maxlength='11'
                :placeholder='$t("party_detail.dialog_add_party_delivery_note_config.method.partyPrefix.tooltip")'
                v-model='dialogAddPartyDeliveryNoteEmissionConfigForm.partyPrefix')
          ods-form-item(
            :label='$t("party_detail.dialog_add_party_delivery_note_config.method.packSequenceNumber.title")',
            prop='packSequenceNumber')
            ods-input(
              :placeholder='$t("party_detail.dialog_add_party_delivery_note_config.method.packSequenceNumber.tooltip")'
                v-model='dialogAddPartyDeliveryNoteEmissionConfigForm.packSequenceNumber')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyDeliveryNoteConfig("formDialogAddPartyDeliveryNoteEmissionConfig")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo CONFIGURACIÓN DE TIPOS DE ALBARANES ASOCIADOS A LA EMPRESA
    ods-dialog(
      ref='dialogAddPartyDeliveryNoteType',
      :title='$t("party_detail.dialog_add_party_delivery_note_type.title")',
      :visible.sync='isShowDialogAddPartyDeliveryNoteType',
      @close='handleCloseDialogAddPartyDeliveryNoteType',
      width='20%')
      ods-form(
        ref='formDialogAddPartyDeliveryNoteType',
        :model='dialogAddPartyDeliveryNoteTypeForm',
        :rules='rulesDialogAddPartyDeliveryNoteTypeForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_party_delivery_note_type.method.deliveyNoteType")',
            :default='5'
            prop='deliveryNoteTypeId')
            ods-select(
                  v-model='dialogAddPartyDeliveryNoteTypeForm.deliveryNoteTypeId',
                  :disabled='(optionsDeliveryNoteType && optionsDeliveryNoteType.length === 1)')
                  ods-option(
                    v-for='deliveryNoteType in optionsDeliveryNoteType',
                    :key='deliveryNoteType.deliveryNoteTypeId',
                    :label='formatterDeliveryNoteType(deliveryNoteType)',
                    :value='deliveryNoteType.deliveryNoteTypeId')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyDeliveryNoteType("formDialogAddPartyDeliveryNoteType")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo CONFIGURACIÓN ENVÍOS
    ods-dialog(
      ref='dialogAddPartyGlnConfiguration',
      :title='$t("party_detail.dialog_add_shipping_configuration.title")',
      :visible.sync='isShowDialogPartyGlnConfiguration',
      @close='handleCloseDialogPartyGlnConfiguration',
      width='30%')
      ods-form(
        ref='formDialogAddPartyGlnConfiguration',
        :model='dialogPartyGlnConfigurationForm',
        :rules='rulesDialogPartyGlnConfigurationForm')
          ods-form-item(
            prop='documentType',
            :label='$t("party_detail.dialog_add_shipping_configuration.document_type.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeDocumentType',
              v-model='dialogPartyGlnConfigurationForm.documentType',
              filterable,
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.document_type.placeholder")')
              ods-option(
                v-for='option in partyDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.id')
          ods-form-item(
            prop='documentFormat',
            :label='$t("party_detail.dialog_add_shipping_configuration.document_format.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyGlnConfigurationForm.documentFormat',
              filterable,
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.document_format.placeholder")')
              ods-option(
                v-for='option in partyDocumentFormatByType',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            prop='partyGLNBuyer',
            :label='$t("party_detail.dialog_add_shipping_configuration.gln_buyer.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyGlnConfigurationForm.partyGLNBuyer',
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.gln_buyer.placeholder")',
              filterable)
              ods-option(
                v-for='option in partygln',
                :key='option.id',
                :label="option.physicalGln",
                :value='option.id')
          ods-form-item(
            prop='deliveryPoint',
            :label='$t("party_detail.dialog_add_shipping_configuration.delivery_centre.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyGlnConfigurationForm.deliveryPoint',
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.delivery_centre.placeholder")',
              filterable)
              ods-option(
                v-for='option in optionsDeliveryPointCentre',
                :key='option.id',
                :label='option.centreCode + (option.description?" - " + option.description:"")',
                :value='option.id')
          ods-form-item(
            prop='partySeller',
            :label='$t("party_detail.dialog_add_shipping_configuration.seller.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeGlnConfigurationParty',
              v-model='dialogPartyGlnConfigurationForm.partySeller',
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.seller.placeholder")',
              filterable,
              :filter-method='filterGlnConfigurationPartiesSeller')
              ods-option(
                v-for='option in optionsFilterSellerParty',
                :key='option.id',
                :value='option.id',
                :label='(option.taxIdentificationNumber?option.taxIdentificationNumber + " - ":"") + option.tradeName')
          ods-form-item(
            prop='partyGLNSeller',
            v-if='showGlnConfigurationSellerGln',
            :label='$t("party_detail.dialog_add_shipping_configuration.gln_seller.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPartyGlnConfigurationForm.partyGLNSeller',
              :placeholder='$t("party_detail.dialog_add_shipping_configuration.gln_seller.placeholder")',
              filterable)
              ods-option(
                v-for='option in optionsFilterSellerPartyGln',
                :key='option.id',
                :label="option.physicalGln",
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addPartyGlnConfiguration("formDialogAddPartyGlnConfiguration")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir datos de pago
    ods-dialog(
      ref='dialogAddPaymentMeans'
      :title='$t("party_detail.dialog_add_payments.title")',
      :visible.sync='isShowDialogPaymentMeans',
      @close='handleCloseDialogPaymentMeans',
      width='30%')
      ods-form(
        ref='formDialogdialogAddPaymentMeans',
        :model='formDialogdialogAddPaymentMeans',
        :rules='rulesDialogPaymentMeansForm')
          ods-form-item(
            :label='$t("new_invoice.invoice_totals.dialog_add_installment.form_add_installment.payment_means.title")',
            prop='paymentMeans')
            ods-select(
              v-model='formDialogdialogAddPaymentMeans.paymentMeans',
              filterable,
              @change='getPaymentMean')
              ods-option(
                v-for='option in optionsPaymentMeans',
                :key='option.id',
                :label='getPaymentMeansLabel(option.code)',
                :value='option.id')
          ods-form-item(
            v-if='isPaymentByBank',
            :label='$t("new_invoice.invoice_totals.dialog_add_installment.form_add_installment.iban")',
            prop='iban')
            ods-input(
              v-model='formDialogdialogAddPaymentMeans.iban')
          ods-form-item(
            v-if='isPaymentByBank',
            :label='$t("new_invoice.invoice_totals.dialog_add_installment.form_add_installment.bic")',
            prop='swift')
            ods-input(
              v-model='formDialogdialogAddPaymentMeans.swift')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddPayment("formDialogdialogAddPaymentMeans")')
          | {{ $t('buttons.btnAdd') }}
    //- Dialogo añadir ciclo de documento
    ods-dialog(
      ref='dialogAddPartyDocumentCycle'
      :title='$t("party_detail.dialog_add_document_cycle.title")',
      :visible.sync='isShowDialogPartyDocumentCycle',
      @close='handleCloseDialogPartyDocumentCycle',
      width='30%')
      ods-form(
        ref='formDialogAddPartyDocumentCycle',
        :model='formDialogAddPartyDocumentCycle',
        :rules='rulesDialogAddPartyDocumentCycle')
          ods-form-item(
            prop='sourceDocumentType',
            :label='$t("party_detail.dialog_add_document_cycle.source_document_type.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangePartyDocumentCycleSourceDocumentType',
              v-model='formDialogAddPartyDocumentCycle.sourceDocumentType',
              filterable,
              :placeholder='$t("party_detail.dialog_add_document_cycle.source_document_type.placeholder")')
              ods-option(
                v-for='option in partyDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.code')
          ods-form-item(
            prop='destinationDocumentType',
            :label='$t("party_detail.dialog_add_document_cycle.destination_document_type.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangePartyDocumentCycleDestinationDocumentType'
              v-model='formDialogAddPartyDocumentCycle.destinationDocumentType',
              filterable,
              :placeholder='$t("party_detail.dialog_add_document_cycle.destination_document_type.placeholder")')
              ods-option(
                v-for='option in partyDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.code')
          ods-form-item(
            prop='partySeller',
            :label='$t("party_detail.dialog_add_document_cycle.seller.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='formDialogAddPartyDocumentCycle.partySeller',
              :placeholder='$t("party_detail.dialog_add_document_cycle.seller.placeholder")',
              filterable,
              clearable,
              :filter-method='filterGlnConfigurationPartiesSeller')
              ods-option(
                v-for='option in optionsFilterSellerParty',
                :key='option.id',
                :value='option.id',
                :label='(option.taxIdentificationNumber ? option.taxIdentificationNumber + " - " : "") + option.tradeName')
          ods-form-item(
            prop='centreBuyer',
            :label='$t("party_detail.dialog_add_document_cycle.centre_buyer.label")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='formDialogAddPartyDocumentCycle.centreBuyer',
              :placeholder='$t("party_detail.dialog_add_document_cycle.centre_buyer.placeholder")',
              filterable,
              clearable)
              ods-option(
                v-for='option in optionsPartyDocumentCycleCentre',
                :key='option.id',
                :label='option.centreCode + (option.description ? " - " + option.description : "")',
                :value='option.id')
          ods-form-item(
            v-if='isSelectedPartySourceDocumentType && isSelectedPartyDestinationDocumentType',
            prop='documentCycleClassSource',
            :label='$t("party_detail.dialog_add_document_cycle.document_cycle_class_source.label")')
            ods-select(
              @change='onChangeDocumentCycleClassSource',
              v-model='formDialogAddPartyDocumentCycle.documentCycleClassSource',
              :placeholder='$t("party_detail.dialog_add_document_cycle.document_cycle_class_source.placeholder")',
              clearable)
              ods-option(
                v-for='option in optionsDocumentCycleClassSource',
                :key='option.code',
                :label="$t('party_detail.document_cycle_class_source_options.' + option.code)",
                :value='option.value')
          ods-form-item(
            v-if='isShowDocumentCycleClassOptions',
            :label='$t("party_detail.dialog_add_document_cycle.document_cycle.label")',
            prop='documentCycleClass')
            ods-select(
              v-model='formDialogAddPartyDocumentCycle.documentCycleClass',
              :placeholder='$t("party_detail.dialog_add_document_cycle.document_cycle.placeholder")',
              filterable,
              clearable)
              ods-option(
                v-for='option in optionsDocumentCycleClass',
                :key='option.id',
                :title= 'option.description',
                :label="$t('document_cycle_class.' + option.name)",
                :value='option.name')
          ods-form-item(
            v-if='isShowDocumentCycleClassOptions'
            :label='$t("party_detail.dialog_add_document_cycle.additional_class_value.title")',
            prop='additionalClassValue')
            ods-input(
              v-model='formDialogAddPartyDocumentCycle.additionalClassValue')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddPartyDocumentCycle("formDialogAddPartyDocumentCycle")')
          | {{ $t('buttons.btnAdd') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import moment from 'moment'
import Utils from '@/components/shared/Utils'
import IBAN from 'iban'

export default {
  name: 'b2b-page-parties-services',
  mixins: [Utils],
  data () {
    const self = this
    const checkNumber = (rule, value, callback) => {
      console.log('self.validationname: ', self.validationname)
      self.validationValue = self.dialogValidationsForm.value
      if (value === '') {
        callback()
      } else {
        if (self.validationname && (self.validationname.indexOf('ACCOUNTING') >= 0 || self.validationname.indexOf('accounting') >= 0 ||
        self.validationname.toUpperCase().indexOf('TOTAL') >= 0 ||
        self.validationname.indexOf('contables') >= 0 || self.validationname.indexOf('contabili') >= 0 || self.validationname.indexOf('contábeis') >= 0)) {
          if (!this.checkCorrectNumber(value, false)) {
            if (this.getCharFailedNumeric(value) === 'NoNumeric') {
              callback(new Error(this.$t('msg_generics.format_invalid')))
            } else {
              callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
            }
          } else if (this.countDecimals(value) > 6) {
            callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
          } else {
            self.validationValue = parseFloat(self.dialogValidationsForm.value.replace(',', '.'))
            callback()
          }
        } else {
          callback()
        }
      }
    }
    const checkExtensionLogo = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (!this.validateExtensionLogo(this.formDialogAddLogo.fichero.name)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '. ' + this.$t('projects.error.wrongLogoExtension')))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    const checkFileSize = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (this.formDialogAddLogo.fichero && this.formDialogAddLogo.fichero.size > (100 * 1024)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('error.file_size.exceeded', { argumento: this.maxFileSize.toString() + ' KB' })))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    const checkIban = (rule, value, callback) => {
      console.log(value)
      if (value == null && this.isPaymentByBank) {
        callback(new Error(this.$t('msg_generics.field_required')))
      } else {
        const country = this.countries.find(c => {
          return c.codeAlfa2 === value.substring(0, 2)
        })
        if (country) {
          if (country.sepa) {
            const regex = RegExp(/[ `!¡¿@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) // eslint-disable-line
            const isIncorrectIban = regex.test(value)
            if (isIncorrectIban) {
              callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_character_incorrect_iban')))
            }

            if (!IBAN.isValid(value)) {
              callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_add_installment_incorrect_iban')))
            }
          }
        } else {
          callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_add_installment_no_correct_country')))
        }
        callback()
      }
    }
    const checkCodeSwift = (rule, value, callback) => {
      const iban = this.formDialogdialogAddPaymentMeans.iban
      const swift = this.formDialogdialogAddPaymentMeans.swift

      if (iban) {
        const country = this.countries.find(c => {
          return c.codeAlfa2 === iban.substring(0, 2)
        })
        if (country) {
          if (country.sepa != null && !country.sepa) {
            if (value == null || value === '') {
              callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_add_installment_sepa_no_swift')))
            } else if (swift.length !== 11 && swift.length !== 8) {
              callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_add_installment_sepa_no_correct_lenght', { code: country.codeAlfa2, swift_length: swift.length })))
            } else {
              this.checkSwift(swift)
              if (!this.isCorrectSwift) {
                callback(new Error(this.$t('new_invoice.new_invoice_form.error.validation.swift')))
              } else {
                callback()
              }
            }
          } else if (value) {
            this.checkSwift(swift)
            if (!this.isCorrectSwift) {
              callback(new Error(this.$t('new_invoice.new_invoice_form.error.validation.swift')))
            } else {
              callback()
            }
          }
        } else {
          callback(new Error(this.$t('new_invoice.invoice_totals.dialog_add_installment.notify.error_add_installment_no_correct_country')))
        }
      }
      callback()
    }
    return {
      // Datos del project-party
      validationname: null,
      validationValue: null,
      isSelectedSpain: true,
      isSuperAdmin: false,
      userCanChangeMasterData: false,
      projectParty: null,
      enable: null,
      serviceId: null,
      withProject: true,
      projectNamePP: null,
      partyId: null,
      canModifyMasterData: true,
      canModifyRole: true,
      canModifyParty: true,
      extensionFormats: ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tif', '.tiff'],
      projectPartiesDetailEditForm: {
        // Propiedades party
        taxIdentificationNumber: null,
        gln: null,
        personTypeCode: null,
        corporateName: null,
        tradeName: null,
        name: null,
        firstSurname: null,
        secondSurname: null,
        address: null,
        postcode: null,
        town: null,
        province: null,
        countryId: null,
        sheet: null,
        folio: null,
        section: null,
        volume: null,
        book: null,
        additionalRegistrationData: null,
        enable: null,
        projectpartyenable: null,
        editable: null,
        editableAddress: null,
        editableMercantil: null,
        editableRegMercantil: null,
        editableSheet: null,
        editableBook: null,
        editableVolume: null,
        editableSection: null,
        editableFolio: null,
        editableAdditionalData: null,
        logo: null,
        registerOrCompaniesLocation: null,
        buyer: null,
        seller: null,
        sponsor: null,
        third: null
      },

      // Combo tipo persona
      optionsTypePerson: [
        {
          value: 'J',
          label: this.$t('person_type.legal')
        },
        {
          value: 'F',
          label: this.$t('person_type.physical')
        }
      ],

      // LOGO
      isShowDialogAddLogo: false,
      formDialogAddLogo: {
        fichero: null
      },
      queryPartiesService: {
        partyName: '',
        partyTaxIdNumber: ''
      },
      fileList: [],
      extensionFormatsLogo: ['.jpg', '.jpeg', '.png'],
      maxFileSize: 100,
      rulesDialogAddLogoForm: {
        fichero: [
          {
            required: true,
            message: this.$t('msg_generics.file_selected'),
            trigger: 'click'
          },
          { validator: checkExtensionLogo },
          { validator: checkFileSize }
        ]
      },
      comboTypeList: [],
      comboRoleList: [],

      // DATOS DE CONTACTO
      datapartymedia: [],
      lstNewPartyMedia: [],
      currentRowPartyMedia: {},
      partyMediaMessage: false,
      partyMediaFlag: true,

      // DATOS DE servicios
      projectsParty: [],
      currentRowProjectsParty: {},
      projectsPartyMessage: false,
      projectsPartyFlag: true,

      pdfDataFlag: true,
      pdfDataMessage: false,
      // PDF
      pdfData: [],
      currentRowPDF: [],
      optionsPartyPDFVisualizations: [],
      isShowDialogPDFVisualizations: false,
      dialogPDFVisualizationsForm: [],
      rulesDialogPDFVisualizationsForm: {
        visualizationId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },
      dialogAddPartyLabelForm: [],
      optionsPartyLabel: [],
      rulesDialogAddPartyLabelForm: {
        labelId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },
      isSelectedDocType: false,
      isShowDialogPartyMedia: false,

      dialogPartyMediaForm: {
        mediaTypeId: null,
        rol: null,
        value: null
      },

      rulesPartyMediaForm: {
        mediaTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ],
        rol: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ],
        value: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          }
        ]
      },
      // BUZONES
      partygln: [],
      currentRowPartyGln: {},
      partyGlnMessage: false,
      partyGlnFlag: true,

      isShowDialogPartyGln: false,

      dialogPartyGlnForm: {
        physicalGln: null
      },

      rulesPartyGlnForm: {
        physicalGln: [
          {
            required: true,
            message: this.$t('msg_generics.field_required')
          },
          {
            max: 15,
            message: this.$t('msg_generics.max_num_character', { max: 15 }),
            trigger: 'change'
          }
        ]
      },

      // FORMATO DOCUMENTOS
      partyDocumentFormat: [],
      partyDeliveryNoteConfig: [],
      partyDeliveryNoteType: [],
      partyLabel: [],
      optionsDeliveryNoteType: [],
      partyDocumentType: [],
      partyDocumentFormatByType: [],
      currentRowPartyDocumentFormat: {},
      currentRowAddPartyEmissionDeliveryNoteConfig: {},
      currentRowAddPartyDeliveryNoteType: {},
      currentRowAddPartyLabel: {},
      isShowDialogPartyDocumentFormat: false,
      isShowDialogAddPartyDeliveryNoteConfig: false,
      isShowDialogAddPartyDeliveryNoteType: false,
      isShowDialogAddPartyLabel: false,
      partyDocumentFormatMessage: false,
      partyDocumentFormatFlag: true,
      partyEmissionDeliveryNoteConfigFlag: true,
      partyDeliveryNoteTypeFlag: true,
      partyLabelFlag: true,
      partyEmissionDeliveryNoteConfigMessage: false,
      partyDeliveryNoteTypeMessage: false,
      partyLabelMessage: false,
      dialogPartyDocumentFormatForm: {
        documentType: null,
        documentFormat: null,
        senderId: 'emission'
      },
      dialogAddPartyDeliveryNoteEmissionConfigForm: {
        platformCode: 5,
        partyPrefix: null,
        packSequenceNumber: null
      },
      dialogAddPartyDeliveryNoteTypeForm: {
        deliveryNoteTypeId: null
      },
      optionsPartyDocumentFormatSender: [
        {
          id: 'emission',
          name: this.$t('party_type_meth.emission')
        },
        {
          id: 'reception',
          name: this.$t('party_type_meth.reception')
        }
      ],

      // METODOS DE ENTREGA
      communicationsmethods: [],
      currentRowPartyMethod: {},
      isShowDialogDeliveryMehods: false,
      hasCredentials: false,
      isBuyer: false,
      showCommunicationFilter: false,
      communicationsMethodsMessage: false,
      communicationsMethodsFlag: true,
      optionsCommunicationsMethodsSender: [
        {
          id: 'emission',
          name: this.$t('party_type_meth.emission')
        },
        {
          id: 'reception',
          name: this.$t('party_type_meth.reception')
        }
      ],
      dialogCommunicationsMethodsForm: {
        communicationsmethodsId: null,
        password: null,
        user: null,
        communicationsmethodsSenderId: 'emission'
      },

      rulesDialogCommunicationsMethodsForm: {
        communicationsmethodsId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ],
        user: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' }
        ]

      },

      rulesDialogPartyDocumentFormatForm: {
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ],
        documentFormat: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ]
      },
      rulesDialogAddPartyDeliveryNoteEmissionConfigForm: {
        platformCode: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ],
        partyPrefix: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]{7,11}$/, // eslint-disable-line
            message: this.$t('party_detail.dialog_add_party_delivery_note_config.method.rules.partyPrefix_pattern'),
            trigger: 'change'
          }
        ],
        packSequenceNumber: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]+$/, // eslint-disable-line
            message: this.$t('party_detail.dialog_add_party_delivery_note_config.method.rules.packSequenceNumber_pattern'),
            trigger: 'change'
          }
        ]
      },
      rulesDialogAddPartyDeliveryNoteTypeForm: {
        deliveryNoteTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ]
      },

      // VALIDACIONES
      validationsData: [],
      isSeller: false,
      isThird: false,
      isSponsor: false,
      canUpdate: false,
      currentRowValidationsData: [],
      isShowDialogValidations: false,
      isShowValidations: true,
      optionsPartyValidations: [],
      optionsDocumentType: [],
      optionsDocumentTypeDeliveryNoteOnly: [],
      partyValidationsMessage: false,
      partyValidationsFlag: true,

      showComboFormat: false,

      dialogValidationsForm: {},
      rulesDialogValidationsForm: {
        validationId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        role: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        country: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        documentFormat: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        value: [
          { validator: checkNumber, trigger: 'change' }
        ]
      },

      // FIRMA DELEGADA
      dataSignDocument: [],
      currentRowSignDocument: {},
      isShowDialogSignDocument: false,
      signDocumentMessage: false,
      signDocumentFlag: true,
      fileListSignDocument: [],
      formDialogAddSignDocument: {
        file_sign_document: null,
        checkAddAll: false
      },
      // Documentos de datos fiscales
      dataAeatDocument: [],
      currentRowAeatDocument: {},
      aeatDocumentMessage: false,
      aeatDocumentFlag: true,

      // CONFIGURACIÓN DE ENVÍO
      partyGlnConfiguration: [],
      currentRowPartyGlnConfiguration: {},
      isShowDialogPartyGlnConfiguration: false,
      partyGlnConfigurationMessage: false,
      partyGlnConfigurationFlag: true,

      // DATOS DE PAGO
      paymentMeans: [],
      currentRowPaymentMeans: {},
      isShowDialogPaymentMeans: false,
      paymentMeansMessage: false,
      paymentMeansFlag: true,
      optionsPaymentMeans: [],
      isPaymentByBank: false,
      formDialogdialogAddPaymentMeans: {
        paymentMeans: null,
        iban: null,
        swift: null,
        paymentMeansId: null
      },
      isCorrectSwift: false,

      rulesDialogPaymentMeansForm: {
        paymentMeans: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        iban: [
          { validator: checkIban, trigger: 'change' }
        ],
        swift: [
          { validator: checkCodeSwift, trigger: 'change' }
        ]
      },

      optionsFilterSellerParty: [],
      optionsFilterSellerPartyGln: [],
      optionsFilterBuyerPartyGln: [],
      optionsDeliveryPointCentre: [],
      showGlnConfigurationSellerGln: false,

      dialogPartyGlnConfigurationForm: {
        documentType: null,
        documentFormat: null,
        partySeller: null,
        partyBuyer: this.$route.params.partyId,
        deliveryPoint: null,
        partyGLNSeller: null,
        partyGLNBuyer: null
      },

      rulesDialogPartyGlnConfigurationForm: {
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentFormat: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        deliveryPoint: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        partySeller: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        partyGLNBuyer: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        partyGLNSeller: [
          {
            required: false,
            trigger: 'change'
          }
        ]
      },

      // Ciclos de documentos
      partyDocumentCycles: [],
      optionsDocumentCycleClass: [],
      optionsDocumentCycleClassSource: [
        {
          code: 'source',
          value: true
        },
        {
          code: 'destination',
          value: false
        }
      ],
      isShowDocumentCycleClassOptions: false,
      isSelectedPartySourceDocumentType: false,
      isSelectedPartyDestinationDocumentType: false,
      optionsPartyDocumentCycleCentre: [],
      isShowDialogPartyDocumentCycle: false,
      partyDocumentCycleMessage: false,
      partyDocumentCycleFlag: true,
      formDialogAddPartyDocumentCycle: {
        sourceDocumentType: null,
        destinationDocumentType: null,
        partySeller: null,
        centreBuyer: null,
        documentCycleClass: null,
        documentCycleClassSource: null,
        additionalClassValue: null
      },
      rulesDialogAddPartyDocumentCycle: {
        sourceDocumentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        destinationDocumentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        partySeller: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        centreBuyer: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        documentCycleClass: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        documentCycleClassSource: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        additionalClassValue: [
          {
            required: false,
            trigger: 'change'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Combos
      'optionsFilterMediaType',
      'optionsFilterCommunicationsMethods',
      'countries',
      // Permisos
      'canAdminProject',
      'canAdminParty',
      'canAdminIndra',
      'canEditPartyDeliveryMethod',
      'canSeeSingDocument',
      'canAddSingDocument',
      'canDeleteSingDocument',
      'canViewComercialRelation',
      'primaryColor',
      'activeUser',
      'canChangePartyMedia',
      'canModifyPaymentMethods'
    ]),
    rulesDialogSignDocumentForm () {
      const checkExtension = (rule, value, callback) => {
        // Obtener la extension, y cuando la tengas, haces la validacion
        if (!this.validateExtension(this.formDialogAddSignDocument.file_sign_document.name)) {
          this.formDialogAddSignDocument.file_sign_document = null
          this.fileListSignDocument = []
          callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '. ' + this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension_values') + this.extensionFormats.toString()))
        }
        callback()
      }
      return {
        file_sign_document: [
          {
            required: true,
            message: this.$t('msg_generics.file_selected'),
            trigger: 'click'
          },
          { validator: checkExtension }
        ]
      }
    },
    // Datos generales
    projectPartiesDetailEditFormRules () {
      const validaBuyerSeller = (rule, value, callback) => {
        this.$refs.buyerFormItem.clearValidate()
        this.$refs.sellerFormItem.clearValidate()
        this.$refs.thirdFormItem.clearValidate()
        if (!this.projectPartiesDetailEditForm.seller && !this.projectPartiesDetailEditForm.buyer && !this.projectPartiesDetailEditForm.third) {
          callback(new Error(this.$t('auditory_detail.events.property.missing.required.projectparty.role_required')))
        } else {
          callback()
        }
      }
      return {
        taxIdentificationNumber: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        corporateName: [
          {
            required: !this.isSelectedSpain,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 150,
            message: this.$t('msg_generics.max_num_character', { max: 150 }),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        firstSurname: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],

        secondSurname: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        gln: [
          {
            max: 15,
            message: this.$t('msg_generics.max_num_character', { max: 15 }),
            trigger: 'change'
          }
        ],
        address: [
          {
            max: 80,
            message: this.$t('msg_generics.max_num_character', { max: 80 }),
            trigger: 'change'
          }
        ],
        postcode: [
          {
            max: 10,
            message: this.$t('msg_generics.max_num_character', { max: 10 }),
            trigger: 'change'
          }
        ],
        town: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        province: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        sheet: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        folio: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        book: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        section: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        volume: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        additionalRegistrationData: [
          {
            max: 50,
            message: this.$t('msg_generics.max_num_character', { max: 50 }),
            trigger: 'change'
          }
        ],
        registerOrCompaniesLocation: [
          {
            max: 20,
            message: this.$t('msg_generics.max_num_character', { max: 20 }),
            trigger: 'change'
          }
        ],
        buyer: [
          { validator: validaBuyerSeller, trigger: 'blur' },
          { validator: validaBuyerSeller, trigger: 'change' }
        ],
        seller: [
          { validator: validaBuyerSeller, trigger: 'blur' },
          { validator: validaBuyerSeller, trigger: 'change' }
        ],
        third: [
          { validator: validaBuyerSeller, trigger: 'blur' },
          { validator: validaBuyerSeller, trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getPartyService',
      'getProjectPartyService',
      'getPartyMedia',
      'getPartyGln',
      'deletePartyGln',
      'insertPartyGln',
      'getServiceDetail',
      'deletePartyMedia',
      'getOptionsFilterMediaType',
      'getOptionsFilterCommunicationsMethodsParty',
      'insertPartyMedia',
      'getCommunicationsMethodsParty',
      'insertCommunicationsMethodsParty',
      'deleteCommunicationsMethodsParty',
      'deletePartyDocumentFormat',
      'deletePartyEmissionDeliveryNoteConfig',
      'deletePartyDeliveryNoteType',
      'getSingDocument',
      'deleteSingDocument',
      'downloadSingDocument',
      'addSignDocument',
      'getAeatDocument',
      'downloadAeatDocument',
      'getPartyPDFVisualizations',
      'removePartyPDFVisualization',
      'addPartyPDFVisualization',
      'getDisplayDocuments',
      'getDisplayLabels',
      'modifyProjectParty',
      'deleteLogoParty',
      'deleteLogoOnlyParty',
      'downloadLogoParty',
      'getPartyValidations',
      'removePartyValidation',
      'getOptionsDocumentType',
      'getOptionsDeliveryNoteType',
      'getPartyDocFormat',
      'getPartyDeliveryNoteConfig',
      'getPartyDeliveryNoteType',
      'getPartyLabel',
      'getPartyDocumentType',
      'addPartyValidation',
      'canChangeMasterData',
      'canChangeRole',
      'updateMassiveParties',
      'getFormatByDocType',
      'getOptionsFilterFormatDocumentType',
      'insertPartyDocumentFormat',
      'insertPartyDeliveryNoteConfig',
      'insertPartyDeliveryNoteType',
      'insertPartyDisplayLabel',
      'deletePartyDisplayLabel',
      'getOptionsFilterPartyMEFenixBackend',
      'getCentresByPartyCentres',
      'getPartyGlnConfiguration',
      'getPartyPaymentMeans',
      'addGlnConfigurationParty',
      'deleteGlnConfigurationParty',
      'getOptionsPaymentMeans',
      'deletePartyPaymentMeans',
      'addPartyPaymentMeans',
      'getPartyDocumentCycle',
      'addPartyDocumentCycle',
      'deletePartyDocumentCycle',
      'deletePartyDocumentCycleClass',
      'getOptionsDocumentCycleClassByDocumentType',
      'getProjectsParty',
      'updatePartiesService',
      'updateStatusPartiesService'
    ]),

    formatterPartyType (row, column) {
      if (row[column.property]) return this.$t('party_type.' + row[column.property])
      else return '-'
    },
    formatterServiceName (row, column) {
      if (!row.projectName) {
        return this.$t('msg_generics.all')
      }
      return row.projectName
    },
    formatterSenderType (row, column) {
      if (row[column.property] == null) {
        return this.$t('party_type_meth.both')
      } else if (row[column.property]) {
        return this.$t('party_type_meth.emission')
      } else if (!row[column.property]) {
        return this.$t('party_type_meth.reception')
      }
    },
    formatterDeliveryMethods (row, column) {
      if (row[column.property]) {
        return this.$t('communication_method.' + row[column.property])
      }
    },
    formatterDocumentType (row, column) {
      if (row[column.property]) {
        return this.$t('auditory_doc_type.' + row[column.property])
      }
    },
    formatterPayment (row, column) {
      if (row[column.property]) {
        return this.$t('new_invoice.invoice_totals.dialog_add_installment.form_add_installment.payment_means.' + row[column.property])
      }
    },
    formatterDeliveryNoteType (docType) {
      if (docType.deliveryNoteTypeCode === null) {
        return this.$t('delivery_note_type.NO_LOGISTIC')
      } else if (docType.deliveryNoteTypeCode) {
        return this.$t('delivery_note_type.' + docType.deliveryNoteTypeCode)
      }
    },

    formatterLabel (label) {
      if (label.name) {
        return this.$t('display_labels.' + label.name)
      }
    },

    formatterDeliveryCentre (row, column) {
      if (row[column.property]) {
        return (row[column.property] + (row.deliveryCentreName ? ' - ' + row.deliveryCentreName : ''))
      }
      return ''
    },

    //  Reseteo al cerrar dialogo
    handleCloseDialogPartyMedia () {
      this.$refs.formDialogPartyMedia.resetFields()
    },

    //  Reseteo al cerrar dialogo
    handleCloseDialogPartyGln () {
      this.$refs.formDialogPartyGln.resetFields()
    },

    handleCloseDialogPDFVisualizations () {
      this.$refs.formDialogPDFVisualizations.resetFields()
    },

    async handleCloseDialogCommunicationsMethods () {
      this.$refs.formDialogCommunicationsMethods.resetFields()
      this.hasCredentials = false
      this.dialogCommunicationsMethodsForm.communicationsmethodsSenderId = 'emission'
      // await this.getCommunicationsMethodsProject()
      // Combo final métodos de comunicación
      this.getMethodsCommunications()
    },

    handleCloseDialogSignDocument () {
      this.$refs.formDialogAddSignDocument.resetFields()
    },

    handleCloseDialogPartyDocumentFormat () {
      this.$refs.formDialogAddPartyDocumentFormat.resetFields()
    },

    handleCloseDialogAddPartyDeliveryNoteEmissionConfig () {
      this.$refs.formDialogAddPartyDeliveryNoteEmissionConfig.resetFields()
    },

    handleCloseDialogAddPartyDeliveryNoteType () {
      this.$refs.formDialogAddPartyDeliveryNoteType.resetFields()
    },

    handleCloseDialogAddPartyLabel () {
      this.$refs.formDialogAddPartyLabel.resetFields()
    },

    handleCloseDialogPartyGlnConfiguration () {
      this.$refs.formDialogAddPartyGlnConfiguration.resetFields()
    },

    handleCloseDialogPaymentMeans () {
      this.$refs.formDialogdialogAddPaymentMeans.resetFields()
    },

    handleCloseDialogPartyDocumentCycle () {
      this.$refs.formDialogAddPartyDocumentCycle.resetFields()
      this.isShowDocumentCycleClassOptions = false
      this.isShowDialogPartyDocumentCycle = false
      this.isSelectedPartySourceDocumentType = false
      this.isSelectedPartyDestinationDocumentType = false
      this.optionsDocumentCycleClass = []
      this.optionsFilterSellerParty = []
    },

    /* Formatea tipo/servico firma delegada  */
    formatterTypeService (row, column) {
      if (row.projectName) {
        return row.projectName
      } else {
        return 'General'
      }
    },

    formatterVisualizationName (row, column) {
      return this.$t('display_documents.' + row.name)
    },

    formatterDirection (row, column) {
      if (row.issueDirection === true) {
        return this.$t('projects.validities.emission')
      } else if (row.issueDirection === false) {
        return this.$t('projects.validities.reception')
      } else {
        return this.$t('project_type.both')
      }
    },

    // Elimina una validación
    async removeValidation () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_validation')
      })
      try {
        await this.removePartyValidation({
          partyId: this.partyId,
          validationId: this.currentRowValidationsData.id
        })
        await this.getValidationsOnDatabase(true)
        this.$notify({
          title: this.$t('project_detail.notify.delete_validation'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Formatea el tipo de contacto */
    formatterMediaType (row, column) {
      const mediaType = this.optionsFilterMediaType.find(function (elem) {
        return Number(row[column.property]) === elem.id
      })
      if (mediaType) return this.$t('mediaType.' + mediaType.media)
      else return '-'
    },

    formatterName (row, column) {
      return this.replaceValidationPoints(row.name)
    },

    replaceValidationPoints (val) {
      const validationsFormat = val.split('.').join('_')
      return this.$t('validations.data.' + validationsFormat)
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    onChangeCommunicationsMethods (data) {
      this.dialogCommunicationsMethodsForm.user = ''
      this.dialogCommunicationsMethodsForm.password = ''
      this.getCommunicationsMethod(data, true)
    },
    onChangeValidation (data) {
      this.validationname = null
      this.validationValue = null
      console.log('Data validation: ', data)
      const opt = this.optionsPartyValidations.find(function (c) {
        return c.idBusinessValidation === data
      })
      if (opt) {
        console.log('name validation: ', opt.name)
        this.validationname = opt.name
      }
    },

    async onChangeDocumentType (data) {
      // Inicializamos el formato de documento seleccionado
      this.dialogPartyDocumentFormatForm.documentFormat = null
      this.dialogPartyGlnConfigurationForm.documentFormat = null

      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      // Obtener formatos de documentos por tipo
      try {
        this.partyDocumentFormatByType = await this.getOptionsFilterFormatDocumentType(data)
        if (this.partyDocumentFormatByType.length > 0) {
          this.showComboFormat = true
        } else {
          this.showComboFormat = false
          this.dialogValidationsForm.documentFormat = null
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    onChangePartyDocumentCycleSourceDocumentType () {
      if (!this.isSelectedPartySourceDocumentType) {
        this.isSelectedPartySourceDocumentType = true
      }
    },

    onChangePartyDocumentCycleDestinationDocumentType () {
      if (!this.isSelectedPartyDestinationDocumentType) {
        this.isSelectedPartyDestinationDocumentType = true
      }
    },

    async onChangeDocumentCycleClassSource (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      // Obtener formatos de documentos por tipo
      try {
        this.formDialogAddPartyDocumentCycle.documentCycleClass = null
        this.optionsDocumentCycleClass = []

        if (data != null && data !== '') {
          // Obtener clases en función del sentido seleccionado (true -> documento origen, false -> documento destino)
          let documentTypeCode = this.formDialogAddPartyDocumentCycle.sourceDocumentType
          if (!data) {
            documentTypeCode = this.formDialogAddPartyDocumentCycle.destinationDocumentType
          }
          const documentType = this.partyDocumentType.find(function (c) {
            return c.code === documentTypeCode
          })
          this.optionsDocumentCycleClass = await this.getOptionsDocumentCycleClassByDocumentType(documentType.id)

          this.isShowDocumentCycleClassOptions = this.optionsDocumentCycleClass.length > 0
        } else {
          this.formDialogAddPartyDocumentCycle.documentCycleClassSource = null
          this.formDialogAddPartyDocumentCycle.additionalClassValue = null
          this.isShowDocumentCycleClassOptions = false
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async onChangeGlnConfigurationParty (data) {
      if (data) {
        this.dialogPartyGlnConfigurationForm.partySeller = data
        this.dialogPartyGlnConfigurationForm.partyGLNSeller = ''
        this.optionsFilterSellerPartyGln = []
        this.getOptionsFilterSellerPartyGln(data)
        this.showGlnConfigurationSellerGln = true
      }
    },

    async getCommunicationsMethod (data, isChanged) {
      const comm = this.optionsFilterCommunicationsMethods.find(function (c) {
        return c.id === data
      })
      this.hasCredentials = false
      if (comm.credentials) {
        this.hasCredentials = true
      }
    },

    async cancelprojectPartiesDetailEditForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.cancel')
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        await this.getPartyServiceOnDatabase()
        await this.getProjectPartyServiceOnDatabase()
        // Combo tipo de empresa
        this.loadComboPartyMediaTypeParty()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Crea el combo de tipo de configuración */
    loadComboPartyMediaTypeParty () {
      console.log('loadComboPartyMediaTypeParty::init ')

      this.comboTypeList = []
      this.comboRoleList = []

      if (this.projectPartiesDetailEditForm.buyer) {
        this.comboRoleList.push({ code: 'buyer', description: 'projects.validities.reception' })
        this.comboTypeList.push({ code: 'buyer', description: 'party_type.buyer' })
      }
      if (this.projectPartiesDetailEditForm.seller) {
        this.comboRoleList.push({ code: 'seller', description: 'projects.validities.emission' })
        this.comboTypeList.push({ code: 'seller', description: 'party_type.seller' })
      }
      if (this.projectPartiesDetailEditForm.third) {
        this.comboRoleList.push({ code: 'third', description: 'parties.entity_table.third' })
        this.comboTypeList.push({ code: 'third', description: 'party_type.third' })
      }
      if (this.projectPartiesDetailEditForm.buyer && this.projectPartiesDetailEditForm.seller) {
        this.comboRoleList.push({ code: 'both', description: 'party_type.both' })
        this.comboTypeList.push({ code: 'both', description: 'party_type.both' })
      }
      console.log('loadComboPartyMediaTypeParty::end ')
    },

    async loadPartyMedia () {
      if (this.partyMediaFlag) {
        // Tipo de contacto de un partymedia
        const typePromise = this.getOptionsFilterMediaType()
        // Get datos de contacto-partymedia
        const mediaPromise = this.getPartyMediaOnDatabase()

        // Esperamos a tener todos los datos, para mostrarlo
        this.partyMediaFlag = false
        await typePromise
        await mediaPromise
        this.partyMediaMessage = true
      }
    },
    async loadProjectsParty () {
      if (this.projectsPartyFlag) {
        // Get datos
        const projectsParty = await this.getProjectsParty({
          page: 0,
          size: 1000,
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.projectsParty = projectsParty.content
        // Esperamos a tener todos los datos, para mostrarlo
        this.projectsPartyFlag = false
        this.projectsPartyMessage = true

        console.log('servicios de la empresa:', this.projectsParty)
      }
    },

    //* * Crea el combo de dirección de Pdf */
    loadComboDirectioinPdfType () {
      this.comboDirectionList = []
      this.comboDirectionList.push({ code: true, description: this.$t('projects.validities.emission') })
      this.comboDirectionList.push({ code: false, description: this.$t('projects.validities.reception') })
      this.comboDirectionList.push({ code: null, description: this.$t('project_type.both') })
      // por defecto mostrará emisión
      this.dialogPDFVisualizationsForm.issueDirection = true
    },

    async loadPartyGln () {
      // Get buzones GLN
      if (this.partyGlnFlag) {
        this.partyGlnFlag = false
        await this.getPartyGlnOnDatabase()
        this.partyGlnMessage = true
      }
    },

    async loadAeatDocument () {
      // Documentos fiscales
      if (this.aeatDocumentFlag) {
        this.aeatDocumentFlag = false
        await this.getAeatDocumentOnDatabase()
        this.aeatDocumentMessage = true
      }
    },

    async loadPartyGlnConfiguration () {
      if (this.partyGlnConfigurationFlag) {
        this.partyGlnConfigurationFlag = false
        // Buzones físicos de la empresa
        const partyBuyerGlnPromise = this.getPartyGlnOnDatabase()
        // Combo configuración de envío
        const glnConfigurationPromise = this.getPartyGlnConfigurationOnDatabase()

        // Opciones centros con el tipo de rol: lugar de entrega
        const dataQuery = {
          query: {
            partyId: this.partyId,
            centreRoleType: 'ship_to'
          }
        }
        const response = await this.getCentresByPartyCentres(dataQuery)
        this.optionsDeliveryPointCentre = response.data.content
        await glnConfigurationPromise
        await partyBuyerGlnPromise
        this.partyGlnConfigurationMessage = true
      }
    },

    async loadPaymentMeans () {
      if (this.paymentMeansFlag) {
        this.paymentMeansFlag = false
        this.paymentMeans = await this.getPartyPaymentMeans({
          serviceId: this.serviceId,
          partyId: this.partyId
        })

        const response = await this.getOptionsPaymentMeans()

        this.optionsPaymentMeans = response.sort((a, b) => (a.description.toUpperCase().localeCompare(b.description.toUpperCase())))
        this.paymentMeansMessage = true
      }
    },

    getPaymentMeansLabel (code) {
      return this.$t('new_invoice.invoice_totals.dialog_add_installment.form_add_installment.payment_means.' + code)
    },

    getPaymentMean (data) {
      const option = this.optionsPaymentMeans.find(item => {
        return item.id === data
      })

      if (option.code === '02' || option.code === '04') {
        this.isPaymentByBank = true
      } else {
        this.isPaymentByBank = false
      }
    },

    checkSwift (bic) {
      if (bic.length === 8) {
        bic = bic + 'XXX'
      }
      const regex = RegExp(/^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$/) // eslint-disable-line
      const isCorrectSwift = regex.test(bic)
      if (isCorrectSwift) {
        this.isCorrectSwift = true
      } else {
        this.isCorrectSwift = false
      }
    },

    async loadSignDocument () {
      // Get Documentos de firma delegada
      if (this.canSeeSingDocument && this.signDocumentFlag) {
        this.signDocumentFlag = false
        await this.getSingDocumentOnDatabase()
        this.signDocumentMessage = true
      }
    },

    async loadPartyDocumentFormat () {
      // Get Formato de documentos
      if (this.partyDocumentFormatFlag) {
        this.partyDocumentFormatFlag = false
        await this.getPartyDocumentFormatOnDatabase()
        this.partyDocumentFormatMessage = true
      }
    },

    async loadPartyEmissionDeliveryNoteConfig () {
      // Get configuracion de matriculas para albaranes emitidos
      if (this.partyEmissionDeliveryNoteConfigFlag) {
        this.partyEmissionDeliveryNoteConfigFlag = false
        await this.getPartyEmissionDeliveryNoteConfigOnDatabase()
        this.partyEmissionDeliveryNoteConfigMessage = true
      }
    },

    async loadPartyDeliveryNoteType () {
      // Get configuracion de tipos de albaranes
      this.optionsDeliveryNoteType = []
      this.optionsDeliveryNoteType = await this.getOptionsDeliveryNoteType()
      if (this.partyDeliveryNoteTypeFlag) {
        this.partyDeliveryNoteTypeFlag = false
        await this.getPartyDeliveryNoteTypeOnDatabase()
        this.partyDeliveryNoteTypeMessage = true
      }
    },

    async loadPartyLabel () {
      // Carga de tipos de documentos cuando se vaya aplicar para todos los documentos
      // this.optionsDocumentType = []
      // this.optionsDocumentType = await this.getOptionsDocumentType()
      await this.getDocumentTypeDeliveryNote()
      this.dialogAddPartyLabelForm.documentType = this.optionsDocumentTypeDeliveryNoteOnly[0]
      if (this.partyLabelFlag) {
        this.partyLabelFlag = false
        await this.getPartyLabelOnDatabase()
        this.partyLabelMessage = true
      }
    },

    async loadPartyDocumentCycle () {
      // Carga de ciclos de documentos de la empresa
      if (this.partyDocumentCycleFlag) {
        this.partyDocumentCycleFlag = false
        await this.getPartyDocumentCycleOnDatabase()
        this.partyDocumentCycleMessage = true

        // Opciones centros de la empresa
        const dataQuery = {
          query: {
            partyId: this.partyId
          }
        }
        const response = await this.getCentresByPartyCentres(dataQuery)
        this.optionsPartyDocumentCycleCentre = response.data.content
      }
    },

    async loadPartyValidations () {
      // Solo si es Seller y Sponsor se hacen visibles las validaciones
      if (this.isSponsor && this.userCanChangeMasterData && this.partyValidationsFlag) {
        this.partyValidationsFlag = false
        await this.getValidationsOnDatabase(true)
        this.partyValidationsMessage = true
      }
    },

    async loadCommunicationsMethods () {
      // Solo si es comprador se hacen visibles los métodos de entrega
      console.log('Obtenemos los métodos de entrega ', this.isBuyer)
      if (this.isBuyer && this.communicationsMethodsFlag) {
        // Get Metodos de entrega
        this.communicationsMethodsFlag = false
        await this.getCommunicationsMethodsPartyOnDatabase()
        this.communicationsMethodsMessage = true
      }
    },

    /* Redirige a las relaciones comerciales */
    async handleGoCommercialRelation () {
      const response = await this.getServiceDetail(this.serviceId)
      sessionStorage.setItem('partyName', this.projectPartiesDetailEditForm.tradeName)
      sessionStorage.setItem('projectName', response.name)

      router.push({
        name: 'commercial-relation',
        params: {
          projectId: this.projectParty.projectId,
          partyId: this.projectParty.partyId,
          partyName: this.projectPartiesDetailEditForm.tradeName,
          projectName: response.name
        }
      })
    },
    async updateStatusParty (row) {
      console.log('updateStatusParty...')
      const copyIds = []

      copyIds[0] = row.partyId

      const request = {
        projectId: row.projectId,
        partyId: copyIds,
        enable: row.enable
      }
      await this.updateStatusPartiesService(request)

      this.$notify({
        title: this.$t('party_detail.notify.save_changes'),
        type: 'success',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
    },
    updateSponsor (row) {
      this.goUpdatePartiesService(row)
    },
    updateThird (row) {
      if (!row.seller && !row.buyer && !row.third) {
        const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
        row.third = true
        this.showNotificationError(error)
      } else {
        this.goUpdatePartiesService(row)
      }
    },
    async updateSeller (row) {
      if (!row.seller && !row.buyer && !row.third) {
        const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
        row.seller = true
        this.showNotificationError(error)
      } else {
        await this.goUpdatePartiesService(row)
      }
    },
    updateBuyer (row) {
      if (!row.seller && !row.buyer && !row.third) {
        const error = { data: { message: this.$t('auditory_detail.events.property.missing.required.projectparty.role_required') } }
        row.buyer = true
        this.showNotificationError(error)
      } else {
        this.goUpdatePartiesService(row)
      }
    },
    async goUpdatePartiesService (row) {
      console.log('goUpdatePartiesService...')
      try {
        const copyIds = []
        copyIds[0] = row.partyId

        const request = {
          projectId: row.projectId,
          partyId: copyIds,
          seller: row.seller,
          sponsor: row.sponsor,
          buyer: row.buyer,
          third: row.third
        }
        const response = await this.updatePartiesService(request)
        this.$notify({
          title: this.$t('party_detail.notify.save_changes'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        row.sponsor = response.data[0].sponsor
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async goUpdatePartiesBuyerService (row) {
      console.log('goUpdatePartiesBuyerService...')
      try {
        const copyIds = []
        copyIds[0] = row.partyId

        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          buyer: row.buyer
        }
        const response = await this.updatePartiesService(request)
        row.sponsor = response.data[0].sponsor
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async goUpdatePartiesThirdService (row) {
      console.log('goUpdatePartiesThirdService...')
      try {
        const copyIds = []
        copyIds[0] = row.partyId

        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          third: row.third
        }
        const response = await this.updatePartiesService(request)
        row.sponsor = response.data[0].sponsor
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async goUpdatePartiesSponsorService (row) {
      console.log('goUpdatePartiesSponsorService...')
      try {
        const copyIds = []
        copyIds[0] = row.partyId
        const request = {
          projectId: this.$route.params.projectId,
          partyId: copyIds,
          sponsor: row.sponsor
        }
        const response = await this.updatePartiesService(request)
        row.sponsor = response.data[0].sponsor
        console.log('sponsor: ', row.sponsor)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async handleGoMassiveUpdate () {
      let projectId = null
      if (this.withProject) {
        projectId = this.projectParty.projectId
      }
      const dataQuery = {
        query: {},
        serviceId: projectId
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.update_party')
      })
      try {
        this.queryPartiesService.partyName = ''
        this.queryPartiesService.partyTaxIdNumber = this.projectPartiesDetailEditForm.taxIdentificationNumber
        this.queryPartiesService.projectId = projectId
        dataQuery.query = this.queryPartiesService

        await this.updateMassiveParties(dataQuery)
        this.$notify({
          title: this.$t('msg_generics.update_party_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        // Actualizamos los detalles de la empresa
        await this.getPartyNameUpdated()
      } catch (error) {
        console.log('handleGoMassiveUpdate CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Redirige a los centros  de un servicio */
    async handleGoCenters () {
      let projectId = null
      let projectName = null
      let routerName = 'table-centres'
      if (this.withProject) {
        const response = await this.getServiceDetail(this.serviceId)
        sessionStorage.setItem('partyName', this.projectPartiesDetailEditForm.tradeName)
        sessionStorage.setItem('projectName', response.name)

        projectId = this.projectParty.projectId
        projectName = response.name
      } else {
        routerName = 'table-centres-party'
      }

      router.push({
        name: routerName,
        params: {
          projectId: projectId,
          partyId: this.$route.params.partyId,
          projectName: projectName,
          partyName: this.projectPartiesDetailEditForm.tradeName
        }
      })
    },

    // Acciones del logo
    onSubmitAddLogo (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.upload_logo')
          })
          console.log('submit!!!   ', this.fileList)
          this.projectPartiesDetailEditForm.logo = this.fileList[0]
          this.isShowDialogAddLogo = false
          this.$notify({
            title: this.$t('party_detail.notify.upload_logo'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          load.close()
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    //* *Elimina el logo de la empresa */
    async removeLogo () {
      console.log('removeLogo:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_logo')
      })
      try {
        if (this.serviceId) {
          await this.deleteLogoParty({
            serviceId: this.serviceId,
            partyId: this.partyId
          })
        } else {
          await this.deleteLogoOnlyParty({
            partyId: this.partyId
          })
        }
        await this.getPartyServiceOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_logo'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        await this.getProjectPartyServiceOnDatabase()
        // Combo tipo de empresa
        this.loadComboPartyMediaTypeParty()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    //* *Descarga un documento de firma delegada */
    async downloadLogo () {
      console.log('downloadLogo:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.download_logo')
      })
      try {
        await this.downloadLogoParty({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        await this.getPartyServiceOnDatabase()
        this.$notify({
          title: this.$t('msg_generics.download_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        await this.getProjectPartyServiceOnDatabase()
        // Combo tipo de empresa
        this.loadComboPartyMediaTypeParty()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddLogo.fichero = file
      this.$refs.formDialogAddLogo.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    handleCloseDialogAddLogo () {
      this.$refs.formDialogAddLogo.resetFields()
      this.fileList = []
    },

    handleValidationCellMouseEnter (row, column, cell, event) {
      this.currentRowValidationsData = row
    },

    handlePDFCellMouseEnter (row, column, cell, event) {
      this.currentRowPDF = row
    },

    /** Guarda los cambios del proyecto  */
    saveProjectParty (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('saveProjectParty: ', this.projectPartiesDetailEditForm)
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.save_changes')
          })
          try {
            if (this.datapartymedia.length > 0) {
              for (let index = 0; index < this.datapartymedia.length; index++) {
                const mediaParty = {
                  mediaTypeId: this.datapartymedia[index].mediaTypeId,
                  value: this.datapartymedia[index].mediaValue,
                  buyer: this.datapartymedia[index].buyer,
                  seller: this.datapartymedia[index].seller
                }
                this.lstNewPartyMedia.push(mediaParty)
              }
            }
            const response = await this.modifyProjectParty({
              // Logo
              logo: this.projectPartiesDetailEditForm.logo,
              // Party
              projectPartyData: {
                serviceId: this.serviceId,
                partyId: this.partyId,
                buyer: this.projectPartiesDetailEditForm.buyer,
                seller: this.projectPartiesDetailEditForm.seller,
                third: this.projectPartiesDetailEditForm.third,
                sponsor: this.projectPartiesDetailEditForm.sponsor,
                enable: this.projectPartiesDetailEditForm.projectpartyenable,

                party: {
                  taxIdentificationNumber: this.projectPartiesDetailEditForm
                    .taxIdentificationNumber,
                  gln: this.projectPartiesDetailEditForm.gln,
                  personTypeCode: this.projectPartiesDetailEditForm
                    .personTypeCode,
                  corporateName: this.projectPartiesDetailEditForm
                    .corporateName,
                  tradeName: this.projectPartiesDetailEditForm.tradeName,
                  name: this.projectPartiesDetailEditForm.name,
                  firstSurname: this.projectPartiesDetailEditForm.firstSurname,
                  secondSurname: this.projectPartiesDetailEditForm
                    .secondSurname,
                  address: this.projectPartiesDetailEditForm.address,
                  postcode: this.projectPartiesDetailEditForm.postcode,
                  town: this.projectPartiesDetailEditForm.town,
                  province: this.projectPartiesDetailEditForm.province,
                  countryId: this.projectPartiesDetailEditForm.countryId,
                  sheet: this.projectPartiesDetailEditForm.sheet,
                  folio: this.projectPartiesDetailEditForm.folio,
                  section: this.projectPartiesDetailEditForm.section,
                  volume: this.projectPartiesDetailEditForm.volume,
                  book: this.projectPartiesDetailEditForm.book,
                  additionalRegistrationData: this.projectPartiesDetailEditForm
                    .additionalRegistrationData,
                  enable: this.projectPartiesDetailEditForm.enable,
                  registerOrCompaniesLocation: this.projectPartiesDetailEditForm.registerOrCompaniesLocation
                },
                lstNewPartyMediaRequestTO: this.lstNewPartyMedia
              }
            })

            this.projectPartiesDetailEditForm = response.data
            await this.getPartyServiceOnDatabase()
            await this.getProjectPartyServiceOnDatabase()
            // Combo tipo de empresa
            this.loadComboPartyMediaTypeParty()

            this.$notify({
              title: this.$t('party_detail.notify.save_changes'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log(
            'submitprojectPartiesDetailEditForm: ',
            this.projectPartiesDetailEditForm
          )
        }
      })
    },
    formatterRole (row, column) {
      if (row.sender === true) {
        return this.$t('projects.validities.emission')
      } else if (row.sender === false) {
        return this.$t('projects.validities.reception')
      } else {
        return this.$t('project_type.both')
      }
    },

    showUploadDialog (event) {
      this.isShowDialogAddLogo = true
      if (event) event.preventDefault()
    },

    selectFile (event) {
      if (event) event.preventDefault()
      this.$refs['form-item-upload-sign-document'].clearValidate()
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowPartyMedia = row
    },

    handleCellMouseEnterProjects (row, column, cell, event) {
      this.currentRowProjectsParty = row
    },

    handleCellMouseEnterGln (row, column, cell, event) {
      this.currentRowPartyGln = row
    },

    handleCellMouseEnterMethod (row, column, cell, event) {
      this.currentRowPartyMethod = row
    },

    handleCellMouseEnterFormat (row, column, cell, event) {
      this.currentRowPartyDocumentFormat = row
    },

    handleCellMouseEnterEmissionDeliveryNoteConfig (row, column, cell, event) {
      this.currentRowAddPartyEmissionDeliveryNoteConfig = row
    },

    handleCellMouseEnterDeliveryNoteType (row, column, cell, event) {
      this.currentRowAddPartyDeliveryNoteType = row
    },

    handleCellMouseEnterPartyLabel (row, column, cell, event) {
      this.currentRowAddPartyLabel = row
    },

    handleCellMouseEnterSingDocument (row, column, cell, event) {
      this.currentRowSignDocument = row
    },

    handleCellMouseEnterAeatDocument (row, column, cell, event) {
      this.currentRowAeatDocument = row
    },

    handleCellMouseEnterGlnConfiguration (row, column, cell, event) {
      this.currentRowPartyGlnConfiguration = row
    },
    handleCellMouseEnterPaymentMeans (row, column, cell, event) {
      this.currentRowPaymentMeans = row
    },
    handleCellMouseEnterPartyDocumentCycle (row, column, cell, event) {
      this.currentRowPartyDocumentCycle = row
    },
    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },
    validateExtensionLogo (filename) {
      return this.extensionFormatsLogo.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    validateNewPartyGlnConfiguration (form) {
      // Buscar en partyGlnConfiguration -> que no sea igual Comprador, GLNComprador, Formato y Tipo
      const physicalGlnBuyer = this.partygln.find(function (c) {
        return c.id === form.partyGLNBuyer
      })
      const type = this.partyDocumentType.find(function (c) {
        return c.id === form.documentType
      })
      const format = this.partyDocumentFormatByType.find(function (c) {
        return c.id === form.documentFormat
      })
      const duplicated = this.partyGlnConfiguration.find(function (c) {
        return (c.documentFormat === format.name && c.documentType === type.code && c.partyGlnBuyer === physicalGlnBuyer.physicalGln)
      })
      return !duplicated
    },

    // DATOS DE CONTACTOS PARTYMEDIA
    async getPartyMediaOnDatabase () {
      // Get datos de partymedia
      try {
        const data = await this.getPartyMedia({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.datapartymedia = data
        for (let index = 0; index < this.datapartymedia.length; index++) {
          if (this.datapartymedia[index].buyer && !this.datapartymedia[index].seller) {
            this.datapartymedia[index].typeText = 'buyer'
          } else if (!this.datapartymedia[index].buyer && this.datapartymedia[index].seller) {
            this.datapartymedia[index].typeText = 'seller'
          } else if (!this.datapartymedia[index].buyer && !this.datapartymedia[index].seller && this.datapartymedia[index].third) {
            this.datapartymedia[index].typeText = 'third'
          } else if (this.datapartymedia[index].buyer && this.datapartymedia[index].seller) {
            this.datapartymedia[index].typeText = 'both'
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // BUZONES DE PARTY_GLN
    async getPartyGlnOnDatabase () {
      // Get datos de partygln
      try {
        const data = await this.getPartyGln({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partygln = data
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    /*
    * VALIDACIONES
    * enable: true si queremos obtener las validaciones activaspara esa empresa
    * enable:false si queremos obtener las validaciones que no están activas para la empresa
    */
    async getValidationsOnDatabase (enable) {
      try {
        const dataQuery = {
          partyId: this.partyId,
          enable: enable
        }
        const response = await this.getPartyValidations(dataQuery)
        if (enable === null || enable === true) {
          this.validationsData = response
        } else {
          for (let index = 0; index < response.length; index++) {
            response[index].name = this.$t('validations.data.' + response[index].name.split('.').join('_'))
          }
          // ordenamos las validaciones por el nombre traducido
          response.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))
          this.optionsPartyValidations = response
        }
      } catch (error) {
        this.isShowValidations = false
      }
    },

    //* *Elimina un partymedia */
    async removePartyMedia () {
      console.log('removePartyMedia:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_contact_data')
      })

      try {
        await this.deletePartyMedia({
          serviceId: this.serviceId,
          partyId: this.partyId,
          partyMediaId: this.currentRowPartyMedia.id
        })
        await this.getPartyMediaOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_contact_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async removePartyDocumentCycle () {
      if (this.canAdminIndra) {
        console.log('removePartyDocumentCycle:...')
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_document_cycle')
        })

        try {
          if (this.currentRowPartyDocumentCycle.idPartyDocumentCycleClass) {
            await this.deletePartyDocumentCycleClass({
              serviceId: this.serviceId,
              partyId: this.partyId,
              partyDocumentCycleClassId: this.currentRowPartyDocumentCycle.idPartyDocumentCycleClass,
              deletePartyDocumentCycle: true
            })
          } else {
            await this.deletePartyDocumentCycle({
              serviceId: this.serviceId,
              partyId: this.partyId,
              partyDocumentCycleId: this.currentRowPartyDocumentCycle.id
            })
          }
          await this.getPartyDocumentCycleOnDatabase()
          this.$notify({
            title: this.$t('party_detail.notify.delete_document_cycle'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    //* * Inserta un partyGln */
    addPartyGln (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_gln_data')
          })
          try {
            console.log('addPartyGln VALID: ', this.dialogPartyGlnForm)
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              physicalGln: this.dialogPartyGlnForm.physicalGln
            }
            await this.insertPartyGln(params)
            await this.getPartyGlnOnDatabase()
            this.$notify({
              title: this.$t('party_detail.notify.add_gln_data'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPartyGln = false
          }
        } else {
          console.log('addPartyGln INVALID: ', this.dialogPartyGlnForm)
        }
      })
    },

    //* *Elimina un partygln */
    async removePartyGln () {
      console.log('removePartyGln:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_gln_data')
      })
      try {
        await this.deletePartyGln({
          serviceId: this.serviceId,
          partyId: this.partyId,
          partyglnId: this.currentRowPartyGln.id
        })
        await this.getPartyGlnOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_gln_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async updateOnclickSwitch () {
      this.loadComboPartyMediaTypeParty()
      this.isBuyer = this.projectPartiesDetailEditForm.buyer
      if (this.projectPartiesDetailEditForm.buyer) {
        await this.getCommunicationsMethodsPartyOnDatabase()
      }
    },

    async openDialogDeliveryMehods () {
      this.isShowDialogDeliveryMehods = true

      // Solo si es comprador se hacen visibles los métodos de entrega
      if (this.isBuyer) {
        // Combo método de comunicación
        await this.getCommunicationsMethodsProject()
        // Combo final métodos de comunicación
        this.getMethodsCommunications()
      }
    },

    async openDialogAddPartyLabel () {
      this.optionsDocumentType = []
      this.isSelectedDocType = false
      // this.dialogAddPartyLabelForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.getDocumentTypeDeliveryNote()
        this.optionsDocumentTypeDeliveryNoteOnly[0] = this.dialogAddPartyLabelForm.documentType
        await this.getLabelsByDocumentType(this.optionsDocumentTypeDeliveryNoteOnly[0].id)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
      this.isShowDialogAddPartyLabel = true
    },

    async openDialogAddValidation () {
      this.optionsDocumentType = []
      this.dialogValidationsForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_validation')
      })
      this.optionsDocumentType = await this.getOptionsDocumentType()
      await this.getValidationsOnDatabase(false)
      load.close()
      this.isShowDialogValidations = true
    },
    handleCloseDialogValidations () {
      this.$refs.formDialogValidations.resetFields()
    },
    //* * Inserta un partyMedia */
    addPartyMedia (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_contact_data')
          })
          try {
            console.log('addPartyMedia VALID: ', this.dialogPartyMediaForm)
            let rolbuyer = false
            let rolseller = false
            let rolthird = false
            if (this.dialogPartyMediaForm.rol === 'buyer') {
              rolbuyer = true
            } else if (this.dialogPartyMediaForm.rol === 'seller') {
              rolseller = true
            } else if (this.dialogPartyMediaForm.rol === 'third') {
              rolthird = true
            } else if (this.dialogPartyMediaForm.rol === 'both') {
              rolbuyer = true
              rolseller = true
              rolthird = true
            }
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              mediaTypeId: this.dialogPartyMediaForm.mediaTypeId,
              value: this.dialogPartyMediaForm.value,
              buyer: rolbuyer,
              seller: rolseller,
              third: rolthird
            }
            await this.insertPartyMedia(params)
            await this.getPartyMediaOnDatabase()
            this.$notify({
              title: this.$t('party_detail.notify.add_contact_data'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPartyMedia = false
          }
        } else {
          console.log('addPartyMedia INVALID: ', this.dialogPartyMediaForm)
        }
      })
    },

    // METODOS DE ENTREGA
    async getCommunicationsMethodsPartyOnDatabase () {
      // Get datos de metodo de entrgega de la empresa con ese proyecto
      try {
        this.communicationsmethods = await this.getCommunicationsMethodsParty({
          serviceId: this.serviceId,
          partyId: this.partyId,
          sender: 'ALL'
        })
        if (this.projectPartiesDetailEditForm.buyer && !this.projectPartiesDetailEditForm.sponsor) {
          this.communicationsmethods = await this.getCommunicationsMethodsParty({
            serviceId: this.serviceId,
            partyId: this.partyId,
            sender: 'SENDER'
          })
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Métodos de entrega del servicio
    async getCommunicationsMethodsProject () {
      this.showCommunicationFilter = false
      if (this.projectPartiesDetailEditForm.buyer && !this.projectPartiesDetailEditForm.sponsor) {
        await this.getOptionsFilterCommunicationsMethodsParty({
          serviceId: this.serviceId,
          sender: 'SENDER'
        })
      } else if (this.projectPartiesDetailEditForm.buyer && this.projectPartiesDetailEditForm.sponsor) {
        this.showCommunicationFilter = true
        await this.getOptionsFilterCommunicationsMethodsParty({
          serviceId: this.serviceId,
          sender: 'SENDER'
        })
      }
    },
    onChangeCommunicationsSender (data) {
      this.dialogCommunicationsMethodsForm.optionsFilterCommunicationsMethods = []
      this.dialogCommunicationsMethodsForm.communicationsmethodsId = null
      this.getCommunicationsMethodSender(data, true)
    },
    async getCommunicationsMethodSender (data, isChanged) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const opt = this.optionsCommunicationsMethodsSender.find(function (c) {
          return c.id === data
        })
        if (opt.id === 'emission') {
          await this.getOptionsFilterCommunicationsMethodsParty({
            serviceId: this.serviceId,
            sender: 'SENDER'
          })
        } else {
          await this.getOptionsFilterCommunicationsMethodsParty({
            serviceId: this.serviceId,
            sender: 'RECEIVER'
          })
        }
        // Combo final métodos de comunicación
        this.getMethodsCommunications()
      } finally {
        load.close()
      }
    },

    async onSubmitAddValidation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_validation')
          })
          try {
            if (this.partyDocumentFormatByType.length === 0) {
              this.dialogValidationsForm.documentFormat = null
            }
            const params = {
              partyId: this.partyId,
              projectId: this.serviceId,
              validationId: this.dialogValidationsForm.validationId,
              value: this.validationValue,
              role: this.dialogValidationsForm.role,
              documentType: this.dialogValidationsForm.documentType,
              documentFormat: this.dialogValidationsForm.documentFormat,
              country: this.dialogValidationsForm.country
            }
            await this.addPartyValidation(params)
            await this.getValidationsOnDatabase(true)

            this.$notify({
              title: this.$t('project_detail.notify.add_validation'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogValidations = false
          }
        }
      })
    },

    async onSubmitAddPartyLabel (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_party_label')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              labelId: this.dialogAddPartyLabelForm.labelId,
              documentType: this.dialogAddPartyLabelForm.documentType
            }
            console.log('Params datos etiqueta', params)
            await this.insertPartyDisplayLabel(params)
            await this.getPartyLabelOnDatabase()

            this.$notify({
              title: this.$t('party_detail.notify.add_party_label'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddPartyLabel = false
          }
        }
      })
    },

    async onSubmitAddPDFVisualization (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_visualization')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              visualizationId: this.dialogPDFVisualizationsForm.visualizationId,
              documentType: this.dialogPDFVisualizationsForm.documentType,
              issueDirection: this.dialogPDFVisualizationsForm.issueDirection,
              communicationsmethodsId: this.dialogPDFVisualizationsForm.communicationsmethodsId
            }
            await this.addPartyPDFVisualization(params)
            await this.getPDFVisualizationsOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_PDFVisualization'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPDFVisualizations = false
          }
        }
      })
    },
    // Elimina una visualización PDF
    async removePDFVisualization () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_PDFVisualization')
      })
      try {
        console.log(JSON.stringify(this.currentRowPDF))
        await this.removePartyPDFVisualization({
          serviceId: this.serviceId,
          partyId: this.partyId,
          visualizationId: this.currentRowPDF.id
        })
        await this.getPDFVisualizationsOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_PDFVisualization'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getPDFVisualizationsOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId,
          partyId: this.partyId
        }
        const response = await this.getPartyPDFVisualizations(dataQuery)
        this.pdfData = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async openDialogAddPDFVisualization () {
      this.optionsDocumentType = []
      this.isSelectedDocType = false
      this.dialogPDFVisualizationsForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_visualization')
      })
      await this.getDocumentTypeSorted()
      await this.getPDFVisualizationsOnDatabase()
      load.close()
      this.isShowDialogPDFVisualizations = true
    },

    async getDisplayDocumentsByDocumentType (data) {
      const dataQuery = {
        documentTypeId: data
      }
      this.optionsPartyPDFVisualizations = await this.getDisplayDocuments(dataQuery)
      if (this.optionsPartyPDFVisualizations.length > 0) {
        this.isSelectedDocType = true
      } else {
        this.$notify({
          title: this.$t('project_detail.notify.noDisplayDocuments'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info'
        })
      }
    },
    async getLabelsByDocumentType (data) {
      const dataQuery = {
        documentTypeId: data
      }
      this.optionsPartyLabel = await this.getDisplayLabels(dataQuery)
      if (this.optionsPartyLabel.length > 0) {
        this.isSelectedDocType = true
      } else {
        this.$notify({
          title: this.$t('party_detail.notify.noLabels'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info'
        })
      }
    },
    async loadPdfData () {
      // Get DisplayDocuments
      if (this.pdfDataFlag) {
        this.pdfDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getPDFVisualizationsOnDatabase()
          this.pdfDataMessage = true

          this.loadComboDirectioinPdfType()
          // Get Metodos de entrega
          await this.getCommunicationsMethodsPartyOnDatabase()
        } finally {
          load.close()
        }
      }
    },

    async getDocumentTypeSorted () {
      const response = await this.getOptionsDocumentType()
      for (let index = 0; index < response.length; index++) {
        response[index].code = this.$t('auditory_doc_type.' + response[index].code)
      }
      response.sort((a, b) => (a.code.toUpperCase().localeCompare(b.code.toUpperCase())))
      this.optionsDocumentType = response
    },

    async getDocumentTypeDeliveryNote () {
      const response = await this.getOptionsDocumentType()
      for (let index = 0; index < response.length; index++) {
        if (response[index].code === 'DELIVERYNOTE') {
          response[index].code = this.$t('auditory_doc_type.' + response[index].code)
          this.dialogAddPartyLabelForm.documentType = response[index]
        }
      }
    },

    getMethodsCommunications () {
      try {
        for (let x = 0; x < this.optionsFilterCommunicationsMethods.length; x++) {
          for (const y in this.communicationsmethods) {
            if (this.optionsFilterCommunicationsMethods[x].name === this.communicationsmethods[y].name) {
              // - console.log(  '@@@REPETIDO' + this.optionsFilterCommunicationsMethods[x].name  )
              this.optionsFilterCommunicationsMethods.splice(x, 1)
              if (x >= 0) {
                x--
              }
              break
            }
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    //* * Inserta un método de entrega */
    addCommunicationsMethodsParty (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_delivery_method')
          })
          try {
            console.log(
              'addCommunicationsMethodsParty VALID: ',
              this.dialogCommunicationsMethodsForm
            )
            const copyIds = []
            copyIds[0] = this.partyId
            const params = {
              serviceId: this.serviceId,
              partyId: copyIds,
              communicationsmethodsId: this.dialogCommunicationsMethodsForm
                .communicationsmethodsId,
              user: this.dialogCommunicationsMethodsForm.user,
              password: this.dialogCommunicationsMethodsForm.password,
              allProjects: this.dialogCommunicationsMethodsForm.checkAddAll
            }
            await this.insertCommunicationsMethodsParty(params)
            await this.getCommunicationsMethodsPartyOnDatabase()
            // Combo final métodos de comunicación
            this.getMethodsCommunications()
            this.$notify({
              title: this.$t('party_detail.notify.add_delivery_method'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogDeliveryMehods = false
            this.dialogCommunicationsMethodsForm.checkAddAll = false
          }
        } else {
          console.log(
            'addCommunicationsMethodsParty INVALID: ',
            this.dialogCommunicationsMethodsForm
          )
        }
      })
    },

    //* * Elimina un método de entrega */
    async removeCommunicationsMethodsParty () {
      // Necesita el permiso PARTY_DELIVERY_METHOD para poder eliminar elementos
      if (this.canEditPartyDeliveryMethod) {
        console.log(
          'removeCommunicationsMethodsParty: ',
          this.currentRowPartyMethod.id
        )
        const isAll = (!this.currentRowPartyMethod.projectName)
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_delivery_method')
        })
        try {
          await this.deleteCommunicationsMethodsParty({
            serviceId: this.serviceId,
            partyId: this.partyId,
            communicationsmethodsId: this.currentRowPartyMethod.id,
            priority: this.currentRowPartyMethod.priority,
            allProjects: isAll
          })
          // Cargamos en la tabla los metodos de entrega
          await this.getCommunicationsMethodsPartyOnDatabase()
          // Cargamos el combo de metodos dentrega según perfil de la empresa
          await this.getCommunicationsMethodsProject()
          // Cargamos Combo final métodos de comunicación
          this.getMethodsCommunications()
          this.$notify({
            title: this.$t('party_detail.notify.delete_delivery_method'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Elimina un formato de documento
    async removePartyDocumentFormat () {
      // Necesita el permiso canAdminIndra para poder eliminar elementos
      if (this.canAdminProject) {
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_party_document_format')
        })
        try {
          await this.deletePartyDocumentFormat({
            serviceId: this.serviceId,
            partyId: this.partyId,
            partyDocumentFormatId: this.currentRowPartyDocumentFormat.id
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getPartyDocumentFormatOnDatabase()
          this.$notify({
            title: this.$t('party_detail.notify.delete_party_document_format'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Elimina una matricula asociada a la empresa para albaranes emitidos
    async removePartyEmissionDeliveryNoteConfig () {
      // Necesita el permiso canAdminIndra para poder eliminar elementos
      if (this.canAdminProject) {
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_party_emission_deliverynote_config')
        })
        try {
          await this.deletePartyEmissionDeliveryNoteConfig({
            serviceId: this.serviceId,
            partyId: this.partyId,
            partyDeliveryNoteConfigId: this.currentRowAddPartyEmissionDeliveryNoteConfig.id
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getPartyEmissionDeliveryNoteConfigOnDatabase()
          this.$notify({
            title: this.$t('party_detail.notify.delete_party_emission_deliverynote_config'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Elimina un tipo de albaran asociado a la empresa
    async removePartyDeliveryNoteType () {
      // Necesita el permiso canAdminIndra para poder eliminar elementos
      if (this.canAdminProject) {
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_party_delivery_note_type')
        })
        try {
          await this.deletePartyDeliveryNoteType({
            serviceId: this.serviceId,
            partyId: this.partyId,
            deliveryNoteTypeId: this.currentRowAddPartyDeliveryNoteType.deliveryNoteTypeId
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getPartyDeliveryNoteTypeOnDatabase()
          this.$notify({
            title: this.$t('party_detail.notify.delete_party_delivery_note_type'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Elimina un tipo de albaran asociado a la empresa
    async removePartyLabel () {
      if (this.canAdminIndra) {
        const load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.delete_party_label')
        })
        try {
          await this.deletePartyDisplayLabel({
            serviceId: this.serviceId,
            partyId: this.partyId,
            labelId: this.currentRowAddPartyLabel.id
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getPartyLabelOnDatabase()
          this.$notify({
            title: this.$t('party_detail.notify.delete_party_label'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // DOCUMENTOS DE FIRMA DELEGADA
    async getSingDocumentOnDatabase () {
      // Get datos de Documentos de firma
      try {
        const response = await this.getSingDocument({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.dataSignDocument = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // FORMATO DE DOCUMENTOS
    async getPartyDocumentFormatOnDatabase () {
      // Get datos de formatos de documentos
      try {
        const response = await this.getPartyDocFormat({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partyDocumentFormat = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // MATRICULAS PARA ALBARANES EMITIDOS ASOCIADA A LA EMPRESA
    async getPartyEmissionDeliveryNoteConfigOnDatabase () {
      // Get datos de matricula
      try {
        const response = await this.getPartyDeliveryNoteConfig({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partyDeliveryNoteConfig = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // TIPOS DE ALBARAN ASOCIADOS A LA EMPRESA
    async getPartyDeliveryNoteTypeOnDatabase () {
      // Get datos de tipos de albaranes
      try {
        const response = await this.getPartyDeliveryNoteType({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partyDeliveryNoteType = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // TIPOS DE ALBARAN ASOCIADOS A LA EMPRESA
    async getPartyLabelOnDatabase () {
      // Get datos de tipos de albaranes
      try {
        const response = await this.getPartyLabel({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partyLabel = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // CICLOS DE DOCUMENTOS ASOCIADOS A LA EMPRESA
    async getPartyDocumentCycleOnDatabase () {
      // Get ciclos de documentos
      try {
        const response = await this.getPartyDocumentCycle({
          projectId: this.serviceId,
          partyBuyerId: this.partyId
        })
        this.partyDocumentCycles = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // TIPO DE DOCUMENTOS Formatos de documentos
    async getPartyDocumentTypeOnDatabase () {
      // Get datos de formatos de documentos
      try {
        const response = await this.getPartyDocumentType()
        this.partyDocumentType = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // INSERTAR TIPO DE DOCUMENTO
    async addPartyDocumentFormat (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_document_format')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              partyDocumentFormat: this.dialogPartyDocumentFormatForm
            }
            console.log('addPartyDocumentFormat params: ', params)
            await this.insertPartyDocumentFormat(params)
            this.$notify({
              title: this.$t('party_detail.notify.add_document_format'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getPartyDocumentFormatOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPartyDocumentFormat = false
          }
        } else {
          console.log('addPartyDocumentFormat INVALID: ', this.dialogPartyDocumentFormatForm)
        }
      })
    },

    // INSERTAR NUEVA MATRICULA
    async addPartyDeliveryNoteConfig (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_delivery_note_config')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              partyDeliveryNoteConfig: this.dialogAddPartyDeliveryNoteEmissionConfigForm

            }
            console.log('addPartyDeliveryNoteConfig params: ', params)
            await this.insertPartyDeliveryNoteConfig(params)
            this.$notify({
              title: this.$t('project_detail.notify.add_delivery_note_config'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getPartyEmissionDeliveryNoteConfigOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddPartyDeliveryNoteConfig = false
          }
        } else {
          console.log('addPartyDeliveryNoteConfig INVALID: ', this.dialogAddPartyDeliveryNoteConfigForm)
        }
      })
    },

    // INSERTAR NUEVO TIPO DE ALBARAN
    async addPartyDeliveryNoteType (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_party_delivery_note_type')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              deliveryNoteTypeId: this.dialogAddPartyDeliveryNoteTypeForm.deliveryNoteTypeId

            }
            console.log('addPartyDeliveryNoteType params: ', params)
            await this.insertPartyDeliveryNoteType(params)
            this.$notify({
              title: this.$t('party_detail.notify.add_party_delivery_note_type'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getPartyDeliveryNoteTypeOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddPartyDeliveryNoteType = false
          }
        } else {
          console.log('addPartyDeliveryNoteType INVALID: ', this.dialogAddPartyDeliveryNoteTypeForm)
        }
      })
    },

    //* * Elimina un documento de firma delegada */
    async removeSingDocument () {
      console.log('removeSingDocument...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_sign_document')
      })
      try {
        await this.deleteSingDocument({
          serviceId: this.serviceId,
          partyId: this.partyId,
          singdocumentId: this.currentRowSignDocument.id
        })
        await this.getSingDocumentOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_sign_document'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    //* * Descarga un documento de firma delegada */
    async downloadSingDoc () {
      console.log('downloadSingDoc...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.download_sign_document')
      })
      try {
        await this.downloadSingDocument({
          serviceId: this.serviceId,
          partyId: this.partyId,
          singdocumentId: this.currentRowSignDocument.id
        })
        this.$notify({
          title: this.$t('msg_generics.download_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /** Agrega un documento de firma delegada */
    uploadSignDocument (formName) {
      this.$refs[formName].validate(async valid => {
        if (
          valid &&
          this.fileListSignDocument != null &&
          this.fileListSignDocument.length > 0
        ) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.upload_sign_document')
          })
          try {
            console.log('submit!!!   ', this.fileListSignDocument)
            await this.addSignDocument({
              file: this.fileListSignDocument[0],
              serviceId: this.serviceId,
              partyId: this.partyId,
              allProjects: this.formDialogAddSignDocument.checkAddAll
            })
            await this.getSingDocumentOnDatabase()
            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogSignDocument = false
            this.formDialogAddSignDocument.checkAddAll = false
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    onSuccessUploadSignDocument (fileSignDocument, fileListSignDocument) {
      this.fileListSignDocument = []
      this.fileListSignDocument[0] = fileSignDocument
      this.formDialogAddSignDocument.file_sign_document = fileSignDocument
      this.$refs.formDialogAddSignDocument.validateField('fichero')
    },

    handleRemoveUploadSignDocument (fileSignDocument, fileListSignDocument) {
      this.$refs['form-item-upload-sign-document'].resetField('file_sign_document')
      this.fileListSignDocument = []
    },

    // DOCUMENTOS DE DATOS FISCALES
    async getAeatDocumentOnDatabase () {
      // Get datos de Documentos fiscales
      try {
        const response = await this.getAeatDocument({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.dataAeatDocument = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    //* * Descarga un documento de datos fiscales */
    async downloadAeatDoc () {
      console.log('downloadAeatDoc...')
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.download_aeat_document')
      })
      try {
        await this.downloadAeatDocument({
          serviceId: this.serviceId,
          partyId: this.partyId,
          aeatdocumentId: this.currentRowAeatDocument.id
        })
        this.$notify({
          title: this.$t('msg_generics.download_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getPartyGlnConfigurationOnDatabase () {
      try {
        const response = await this.getPartyGlnConfiguration({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.partyGlnConfiguration = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Añadir una nueva configuración de envío a la empresa
    async addPartyGlnConfiguration (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid && this.validateNewPartyGlnConfiguration(this.dialogPartyGlnConfigurationForm)) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_shipping_configuration')
          })

          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              glnConfiguration: this.dialogPartyGlnConfigurationForm
            }
            await this.addGlnConfigurationParty(params)
            await this.getPartyGlnConfigurationOnDatabase()
            this.$notify({
              title: this.$t('party_detail.notify.add_shipping_configuration'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.isShowDialogPartyGlnConfiguration = false
            this.showGlnConfigurationSellerGln = false
            this.partyDocumentFormatByType = []
            this.optionsFilterSellerParty = []
            this.optionsFilterSellerPartyGln = []
            this.$refs[formName].resetFields()
            load.close()
          }
        } else {
          this.$notify({
            title: this.$t('party_detail.notify.add_shipping_configuration_duplicate'),
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: 10000
          })
        }
      })
    },

    async removePartyGlnConfiguration () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_shipping_configuration')
      })
      try {
        await this.deleteGlnConfigurationParty({
          serviceId: this.serviceId,
          partyId: this.partyId,
          glnConfigurationId: this.currentRowPartyGlnConfiguration.id
        })
        await this.getPartyGlnConfigurationOnDatabase()
        this.$notify({
          title: this.$t('party_detail.notify.delete_shipping_configuration'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async removePartyPaymentMeans () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_paymentMeans')
      })
      try {
        console.log('this.currentRowPaymentMeans ' + JSON.stringify(this.currentRowPaymentMeans))
        await this.deletePartyPaymentMeans({
          serviceId: this.serviceId,
          partyId: this.partyId,
          paymentMeansId: this.currentRowPaymentMeans.paymentMeansId
        })
        this.paymentMeans = await this.getPartyPaymentMeans({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.$notify({
          title: this.$t('party_detail.notify.delete_paymentMeans'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    onSubmitAddPayment (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_paymentMeans')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              partyId: this.partyId,
              paymentMeansId: this.formDialogdialogAddPaymentMeans.paymentMeans,
              iban: this.formDialogdialogAddPaymentMeans.iban,
              swift: this.formDialogdialogAddPaymentMeans.swift
            }
            console.log('paramns ' + JSON.stringify(params))

            await this.addPartyPaymentMeans(params)
            this.paymentMeans = await this.getPartyPaymentMeans({
              serviceId: this.serviceId,
              partyId: this.partyId
            })

            this.isPaymentByBank = false
            this.isShowDialogPaymentMeans = false

            this.$notify({
              title: this.$t('party_detail.notify.add_paymentMeans'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          return false
        }
      })
    },

    async onSubmitAddPartyDocumentCycle (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_party_document_cycle')
          })
          try {
            const params = {
              partyBuyer: this.partyId,
              projectId: this.serviceId,
              partySeller: this.formDialogAddPartyDocumentCycle.partySeller,
              centreBuyer: this.formDialogAddPartyDocumentCycle.centreBuyer,
              sourceDocumentType: this.formDialogAddPartyDocumentCycle.sourceDocumentType,
              destinationDocumentType: this.formDialogAddPartyDocumentCycle.destinationDocumentType,
              documentCycleClass: this.formDialogAddPartyDocumentCycle.documentCycleClass,
              documentCycleClassSource: this.formDialogAddPartyDocumentCycle.documentCycleClassSource,
              additionalClassValue: this.formDialogAddPartyDocumentCycle.additionalClassValue
            }
            console.log('paramns ' + JSON.stringify(params))

            await this.addPartyDocumentCycle(params)

            this.handleCloseDialogPartyDocumentCycle()

            await this.getPartyDocumentCycleOnDatabase()
            this.$notify({
              title: this.$t('party_detail.notify.add_document_cycle'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 9000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error, 8000)
          } finally {
            load.close()
          }
        } else {
          return false
        }
      })
    },

    async getOptionsFilterSellerPartyGln (sellerPartyId) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const data = await this.getPartyGln({
          serviceId: this.serviceId,
          partyId: sellerPartyId
        })
        this.optionsFilterSellerPartyGln = data
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async filterGlnConfigurationPartiesSeller (data) {
      try {
      // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartySellerResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.optionsFilterSellerParty = []
        }
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Obtiene las empresas vendedoras del proyecto
    async getPartySellerResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const dataQuerySeller = {
        role: 'SELLER',
        appFrom: 'B2bPagePartiesServices',
        emission: true,
        seller: true,
        page: 0,
        size: 1000,
        projectId: [this.serviceId],
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(dataQuerySeller)
        this.optionsFilterSellerParty = response
      } catch (error) {
        console.log('getPartySellerResults CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Actualizamos solo el nombre de la empresa en la vista
    async getPartyNameUpdated () {
      try {
        const response = await this.getPartyService({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.projectPartiesDetailEditForm.corporateName = response.corporateName
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Carga la empresa del projectparty
    async getPartyServiceOnDatabase () {
      try {
        const response = await this.getPartyService({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.projectPartiesDetailEditForm = response
        this.canUpdate = false
        if (response.personTypeCode === 'J' && response.countryName === 'España') {
          this.canUpdate = true
        }
        this.isSelectedSpain = false
        if (response.countryName === 'España') {
          this.isSelectedSpain = true
        }
        console.log('Permisos-!(canAdminIndra || (!isSelectedSpain && canModifyMasterData)): ', !(this.canAdminIndra || (!this.isSelectedSpain && this.canModifyMasterData)))
        console.log('Permisos- canAdminIndra: ', this.canAdminIndra)
        console.log('Permisos- isSelectedSpain: ', this.isSelectedSpain)
        console.log('Permisos- canModifyMasterData: ', this.canModifyMasterData)

        console.log('response', response)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Carga el projectparty
    async getProjectPartyServiceOnDatabase () {
      try {
        if (this.partyId && this.$route.params.projectId) {
          const response = await this.getProjectPartyService({
            serviceId: this.$route.params.projectId,
            partyId: this.partyId
          })
          this.projectParty = response
          if (this.projectParty != null && this.projectParty.buyer != null) {
            this.isBuyer = this.projectParty.buyer
          }
          if (this.projectParty != null && this.projectParty.seller != null) {
            this.isSeller = this.projectParty.seller
          }
          if (this.projectParty != null && this.projectParty.third != null) {
            this.isThird = this.projectParty.third
          }
          if (this.projectParty != null && this.projectParty.sponsor != null) {
            this.isSponsor = this.projectParty.sponsor
          }
          this.projectPartiesDetailEditForm.buyer = this.projectParty.buyer
          this.projectPartiesDetailEditForm.seller = this.projectParty.seller
          this.projectPartiesDetailEditForm.third = this.projectParty.third
          this.projectPartiesDetailEditForm.sponsor = this.projectParty.sponsor
          this.projectPartiesDetailEditForm.projectpartyenable = this.projectParty.enable
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getModifyPermission () {
      const userCanChangeMasterDataPromise = this.canChangeMasterData({ projectId: this.serviceId })
      const canModifyRolePromise = this.canChangeRole({ projectId: this.serviceId })

      this.userCanChangeMasterData = await userCanChangeMasterDataPromise
      this.canModifyRole = await canModifyRolePromise

      this.canModifyMasterData = (this.isSponsor && this.userCanChangeMasterData)
      console.log('getModifyPermission- canModifyMasterData: ', this.canModifyMasterData)

      this.canModifyParty = (this.canModifyMasterData && this.canModifyRole)
    },

    async getNotificationErrorMessage (error, delay) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 409:
          if (error.data.message) {
            errorSms = error.data.message
          } else {
            errorSms = 'global_error'
          }
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = 'global_error'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          if (error.data.message) {
            errorSms = error.data.message
          } else {
            errorSms = 'error.default'
          }
          break
      }
      error.data.message = errorSms
      let errorArgList = []
      errorArgList = error.data.errorArgList
      if (errorArgList !== null && errorArgList[0].codesList !== null) {
        for (let i = 0; i < errorArgList.length; i++) {
          let fullMessage = ''
          for (let j = 0; j < errorArgList[i].codesList.length; j++) {
            if (errorArgList[i].codesList != null) {
              fullMessage = fullMessage + errorArgList[i].codesList[j] + '. '
            }
          } if (errorArgList[i].arguments === 'Ok.') {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 60000
            })
          } else {
            await this.$notify({
              title: errorArgList[i].arguments + fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 60000
            })
          }
        }
      } else {
        this.showNotificationError(error, delay)
      }
    },
    showDialogSignDocument (event) {
      console.log('@@@@ showDialogSignDocument ', event)
      this.fileListSignDocument = []
      this.isShowDialogSignDocument = true
    },
    showDialogPartyDocumentFormat () {
      console.log('showDialogPartyDocumentFormat ')
      this.isShowDialogPartyDocumentFormat = true
    },
    showDialogAddPartyDeliveryNoteConfig () {
      console.log('showDialogAddPartyDeliveryNoteConfig ')
      this.isShowDialogAddPartyDeliveryNoteConfig = true
    },
    showDialogAddPartyDeliveryNoteType () {
      console.log('showDialogAddPartyDeliveryNoteType ')
      this.isShowDialogAddPartyDeliveryNoteType = true
    },
    showDialogAddPartyLabel () {
      console.log('showDialogAddPartyLabel')
      this.isShowDialogAddPartyLabel = true
    },
    showDialogPartyGlnConfiguration () {
      console.log('showDialogPartyGlnConfiguration ')
      this.isShowDialogPartyGlnConfiguration = true
    },
    showDialogPaymentMeans () {
      this.isShowDialogPaymentMeans = true
    },
    showDialogPartyDocumentCycle () {
      this.isShowDialogPartyDocumentCycle = true
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Proyecto y empresa
      this.serviceId = this.$route.params.projectId
      this.partyId = this.$route.params.partyId
      // Get Info
      console.log('this.serviceId: ', this.serviceId)
      if (this.serviceId) {
        this.withProject = true
        await this.getPartyServiceOnDatabase()
        // Get projectparty
        await this.getProjectPartyServiceOnDatabase()

        this.isSuperAdmin = this.activeUser.data.isSuperAdmin

        this.loadComboPartyMediaTypeParty()
        this.getPartyDocumentTypeOnDatabase()
        this.getPartyEmissionDeliveryNoteConfigOnDatabase()

        // cargamos permisos
        this.getModifyPermission()
      } else {
        await this.getPartyServiceOnDatabase()

        this.withProject = false
        this.canModifyParty = false
        this.canModifyMasterData = false
        this.canModifyRole = false
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-parties-services {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
      .info_address {
        padding-top: 5px;
        padding-bottom: 30px;
      }
    }

    .subtitle {
      margin-top: 40px;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
    }

  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(0);
          i {
            margin-left: rem(0);
          }
        }
        .first-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
      margin-top: 2rem;
    }

    ::v-deep .ods-module {
      &__body {
        padding: rem(0);
      }
    }
  }

  .ods-tag + .ods-tag {
    margin-left: 10px;
  }
  .botoneraLogo {
    padding-bottom:20px;
    margin-left: 0px;
  }
   .labelNameLogo {
    margin-top: 20px;
    vertical-align: middle;
    text-transform: initial !important;
    padding-bottom: rem(20);
    margin-left: rem(10);
    display: inline-block;
  }
}
</style>
